export const cities = [
  {
    "name": "Abbotsford",
    "countryCode": "CA",
    "stateCode": "BC",
    "latitude": "49.05798000",
    "longitude": "-122.25257000"
  },
  {
    "name": "Abitibi-Témiscamingue",
    "countryCode": "CA",
    "stateCode": "QC",
    "latitude": "48.10018000",
    "longitude": "-77.78280000"
  },
  {
    "name": "Acton Vale",
    "countryCode": "CA",
    "stateCode": "QC",
    "latitude": "45.65007000",
    "longitude": "-72.56582000"
  },
  {
    "name": "Adstock",
    "countryCode": "CA",
    "stateCode": "QC",
    "latitude": "46.05007000",
    "longitude": "-71.08235000"
  },
    {
      "name": "Agassiz",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.23298000",
      "longitude": "-121.76926000"
    },
    {
      "name": "Airdrie",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.30011000",
      "longitude": "-114.03528000"
    },
    {
      "name": "Ajax",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.85012000",
      "longitude": "-79.03288000"
    },
    {
      "name": "Albanel",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.88324000",
      "longitude": "-72.44867000"
    },
    {
      "name": "Alberton",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.81685000",
      "longitude": "-64.06542000"
    },
    {
      "name": "Aldergrove",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.05801000",
      "longitude": "-122.47087000"
    },
    {
      "name": "Aldergrove East",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.05593000",
      "longitude": "-122.42299000"
    },
    {
      "name": "Algoma",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "47.88364000",
      "longitude": "-84.42406000"
    },
    {
      "name": "Alliston",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.15011000",
      "longitude": "-79.86635000"
    },
    {
      "name": "Alma",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.55009000",
      "longitude": "-71.64910000"
    },
    {
      "name": "Altona",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.10469000",
      "longitude": "-97.55961000"
    },
    {
      "name": "Amherst",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.83345000",
      "longitude": "-64.19874000"
    },
    {
      "name": "Amherstburg",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.10009000",
      "longitude": "-83.09985000"
    },
    {
      "name": "Amigo Beach",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.70011000",
      "longitude": "-79.39963000"
    },
    {
      "name": "Amos",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.56688000",
      "longitude": "-78.11624000"
    },
    {
      "name": "Amqui",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.46382000",
      "longitude": "-67.43134000"
    },
    {
      "name": "Ancaster",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.21806000",
      "longitude": "-79.98716000"
    },
    {
      "name": "Ange-Gardien",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.35008000",
      "longitude": "-72.93244000"
    },
    {
      "name": "Angus",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.31681000",
      "longitude": "-79.88295000"
    },
    {
      "name": "Anmore",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.31637000",
      "longitude": "-122.85263000"
    },
    {
      "name": "Annapolis County",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.58345000",
      "longitude": "-65.16551000"
    },
    {
      "name": "Antigonish",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.61685000",
      "longitude": "-61.99858000"
    },
    {
      "name": "Arbutus Ridge",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.24966000",
      "longitude": "-123.16934000"
    },
    {
      "name": "Armstrong",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.44979000",
      "longitude": "-119.20235000"
    },
    {
      "name": "Arnprior",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.43341000",
      "longitude": "-76.34939000"
    },
    {
      "name": "Asbestos",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.76678000",
      "longitude": "-71.93240000"
    },
    {
      "name": "Ashcroft",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.72372000",
      "longitude": "-121.28207000"
    },
    {
      "name": "Assiniboia",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.63336000",
      "longitude": "-105.98446000"
    },
    {
      "name": "Athabasca",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.71687000",
      "longitude": "-113.28537000"
    },
    {
      "name": "Atikokan",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.75667000",
      "longitude": "-91.62409000"
    },
    {
      "name": "Attawapiskat",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "52.92774000",
      "longitude": "-82.41669000"
    },
    {
      "name": "Aurora",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.00011000",
      "longitude": "-79.46632000"
    },
    {
      "name": "Aylmer",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.76679000",
      "longitude": "-80.98302000"
    },
    {
      "name": "Azilda",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.55008000",
      "longitude": "-81.09975000"
    },
    {
      "name": "Baie Ste. Anne",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.05231000",
      "longitude": "-64.95355000"
    },
    {
      "name": "Baie-Comeau",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.21679000",
      "longitude": "-68.14894000"
    },
    {
      "name": "Baie-D'Urfé",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.41397000",
      "longitude": "-73.91586000"
    },
    {
      "name": "Baie-Saint-Paul",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.44109000",
      "longitude": "-70.49858000"
    },
    {
      "name": "Ballantrae",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.03342000",
      "longitude": "-79.29960000"
    },
    {
      "name": "Bancroft",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.05752000",
      "longitude": "-77.85702000"
    },
    {
      "name": "Banff",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.17622000",
      "longitude": "-115.56982000"
    },
    {
      "name": "Barraute",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.43349000",
      "longitude": "-77.63279000"
    },
    {
      "name": "Barrhead",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.13345000",
      "longitude": "-114.40211000"
    },
    {
      "name": "Barrie",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.40011000",
      "longitude": "-79.66634000"
    },
    {
      "name": "Barrière",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "51.18308000",
      "longitude": "-120.11920000"
    },
    {
      "name": "Bas-Saint-Laurent",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.05030000",
      "longitude": "-68.02266000"
    },
    {
      "name": "Bassano",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.78342000",
      "longitude": "-112.46854000"
    },
    {
      "name": "Bath",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.18342000",
      "longitude": "-76.78273000"
    },
    {
      "name": "Bathurst",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.61814000",
      "longitude": "-65.65112000"
    },
    {
      "name": "Bay Roberts",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.59989000",
      "longitude": "-53.26478000"
    },
    {
      "name": "Bay St. George South",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.22781000",
      "longitude": "-58.84162000"
    },
    {
      "name": "Beaconsfield",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.43341000",
      "longitude": "-73.86586000"
    },
    {
      "name": "Beauceville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.21785000",
      "longitude": "-70.77873000"
    },
    {
      "name": "Beauharnois",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.31341000",
      "longitude": "-73.87250000"
    },
    {
      "name": "Beaumont",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.35013000",
      "longitude": "-113.41871000"
    },
    {
      "name": "Beaupré",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.04428000",
      "longitude": "-70.89529000"
    },
    {
      "name": "Beausejour",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.06220000",
      "longitude": "-96.51669000"
    },
    {
      "name": "Beaverlodge",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.21664000",
      "longitude": "-119.43605000"
    },
    {
      "name": "Bedford",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.11678000",
      "longitude": "-72.98244000"
    },
    {
      "name": "Behchokǫ̀",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "62.80250000",
      "longitude": "-116.04639000"
    },
    {
      "name": "Belfast",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.08341000",
      "longitude": "-62.88197000"
    },
    {
      "name": "Belleville",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.16682000",
      "longitude": "-77.38277000"
    },
    {
      "name": "Bells Corners",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.31588000",
      "longitude": "-75.83012000"
    },
    {
      "name": "Belmont",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.88339000",
      "longitude": "-81.08303000"
    },
    {
      "name": "Beloeil",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56839000",
      "longitude": "-73.20568000"
    },
    {
      "name": "Berthierville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.08336000",
      "longitude": "-73.18245000"
    },
    {
      "name": "Berwick",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.05015000",
      "longitude": "-64.73208000"
    },
    {
      "name": "Biggar",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.06680000",
      "longitude": "-108.00135000"
    },
    {
      "name": "Binbrook",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.12135000",
      "longitude": "-79.81104000"
    },
    {
      "name": "Black Diamond",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.70011000",
      "longitude": "-114.23530000"
    },
    {
      "name": "Blackfalds",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.38342000",
      "longitude": "-113.78530000"
    },
    {
      "name": "Blainville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.66678000",
      "longitude": "-73.88249000"
    },
    {
      "name": "Bluewater",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.46679000",
      "longitude": "-81.59977000"
    },
    {
      "name": "Bois-des-Filion",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.66678000",
      "longitude": "-73.74918000"
    },
    {
      "name": "Boisbriand",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.61678000",
      "longitude": "-73.83249000"
    },
    {
      "name": "Boissevain",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.23062000",
      "longitude": "-100.05586000"
    },
    {
      "name": "Bon Accord",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.83345000",
      "longitude": "-113.41872000"
    },
    {
      "name": "Bonaventure",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.04573000",
      "longitude": "-65.49259000"
    },
    {
      "name": "Bonavista",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.64989000",
      "longitude": "-53.11474000"
    },
    {
      "name": "Bonnyville",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.26684000",
      "longitude": "-110.73505000"
    },
    {
      "name": "Botwood",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "49.14994000",
      "longitude": "-55.34819000"
    },
    {
      "name": "Boucherville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.59104000",
      "longitude": "-73.43605000"
    },
    {
      "name": "Bouctouche",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.46844000",
      "longitude": "-64.73905000"
    },
    {
      "name": "Bourget",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.43340000",
      "longitude": "-75.14930000"
    },
    {
      "name": "Bow Island",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.86676000",
      "longitude": "-111.36843000"
    },
    {
      "name": "Bowen Island",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.38470000",
      "longitude": "-123.33622000"
    },
    {
      "name": "Bracebridge",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.03341000",
      "longitude": "-79.31633000"
    },
    {
      "name": "Brampton",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.68341000",
      "longitude": "-79.76633000"
    },
    {
      "name": "Brandon",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.84692000",
      "longitude": "-99.95306000"
    },
    {
      "name": "Brant",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.13340000",
      "longitude": "-80.34967000"
    },
    {
      "name": "Brantford",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.13340000",
      "longitude": "-80.26636000"
    },
    {
      "name": "Breakeyville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.68037000",
      "longitude": "-71.22327000"
    },
    {
      "name": "Bridgewater",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.37856000",
      "longitude": "-64.51882000"
    },
    {
      "name": "Brockville",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.59132000",
      "longitude": "-75.68705000"
    },
    {
      "name": "Bromont",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.31678000",
      "longitude": "-72.64912000"
    },
    {
      "name": "Brooks",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.58341000",
      "longitude": "-111.88509000"
    },
    {
      "name": "Brossard",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.45008000",
      "longitude": "-73.46583000"
    },
    {
      "name": "Brownsburg-Chatham",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.68342000",
      "longitude": "-74.41590000"
    },
    {
      "name": "Brussels",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.73339000",
      "longitude": "-81.24975000"
    },
    {
      "name": "Buckingham",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.58563000",
      "longitude": "-75.42080000"
    },
    {
      "name": "Burford",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.10292000",
      "longitude": "-80.42869000"
    },
    {
      "name": "Burgeo",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.61668000",
      "longitude": "-57.61516000"
    },
    {
      "name": "Burlington",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.38621000",
      "longitude": "-79.83713000"
    },
    {
      "name": "Burnaby",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.26636000",
      "longitude": "-122.95263000"
    },
    {
      "name": "Burns Lake",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.22972000",
      "longitude": "-125.76084000"
    },
    {
      "name": "Bécancour",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.34106000",
      "longitude": "-72.43224000"
    },
    {
      "name": "Cabano",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.68065000",
      "longitude": "-68.87810000"
    },
    {
      "name": "Cache Creek",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.81011000",
      "longitude": "-121.32460000"
    },
    {
      "name": "Cacouna",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.91657000",
      "longitude": "-69.50054000"
    },
    {
      "name": "Calgary",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.05011000",
      "longitude": "-114.08529000"
    },
    {
      "name": "Calmar",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.26683000",
      "longitude": "-113.81874000"
    },
    {
      "name": "Cambridge",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.36010000",
      "longitude": "-80.31269000"
    },
    {
      "name": "Camlachie",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.03596000",
      "longitude": "-82.16160000"
    },
    {
      "name": "Campbell River",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.01634000",
      "longitude": "-125.24459000"
    },
    {
      "name": "Campbellton",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "48.00751000",
      "longitude": "-66.67272000"
    },
    {
      "name": "Camrose",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.01684000",
      "longitude": "-112.83525000"
    },
    {
      "name": "Candiac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.38338000",
      "longitude": "-73.51587000"
    },
    {
      "name": "Canmore",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.08335000",
      "longitude": "-115.35206000"
    },
    {
      "name": "Canora",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.63328000",
      "longitude": "-102.43425000"
    },
    {
      "name": "Cantley",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56680000",
      "longitude": "-75.78265000"
    },
    {
      "name": "Cap-Chat",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.10009000",
      "longitude": "-66.68212000"
    },
    {
      "name": "Cap-Santé",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.67159000",
      "longitude": "-71.78812000"
    },
    {
      "name": "Cape Breton County",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "46.00014000",
      "longitude": "-60.31516000"
    },
    {
      "name": "Capitale-Nationale",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.37600000",
      "longitude": "-71.12337000"
    },
    {
      "name": "Capreol",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.70626000",
      "longitude": "-80.92109000"
    },
    {
      "name": "Carberry",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.86893000",
      "longitude": "-99.36021000"
    },
    {
      "name": "Carbonear",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.73319000",
      "longitude": "-53.21478000"
    },
    {
      "name": "Cardston",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.19998000",
      "longitude": "-113.30190000"
    },
    {
      "name": "Carignan",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.45008000",
      "longitude": "-73.29916000"
    },
    {
      "name": "Carleton",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.09838000",
      "longitude": "-66.10036000"
    },
    {
      "name": "Carleton Place",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.13341000",
      "longitude": "-76.14938000"
    },
    {
      "name": "Carleton-sur-Mer",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.10749000",
      "longitude": "-66.12800000"
    },
    {
      "name": "Carlyle",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.63334000",
      "longitude": "-102.26765000"
    },
    {
      "name": "Carman",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.49920000",
      "longitude": "-98.00156000"
    },
    {
      "name": "Carstairs",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.56681000",
      "longitude": "-114.10200000"
    },
    {
      "name": "Casselman",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.31680000",
      "longitude": "-75.08260000"
    },
    {
      "name": "Castlegar",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.32317000",
      "longitude": "-117.65831000"
    },
    {
      "name": "Catalina",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.51659000",
      "longitude": "-53.08135000"
    },
    {
      "name": "Cedar",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.11633000",
      "longitude": "-123.85270000"
    },
    {
      "name": "Central Coast Regional District",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "52.16638000",
      "longitude": "-127.00323000"
    },
    {
      "name": "Centre-du-Québec",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.01985000",
      "longitude": "-71.98242000"
    },
    {
      "name": "Chambly",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.45008000",
      "longitude": "-73.28246000"
    },
    {
      "name": "Chambord",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.43339000",
      "longitude": "-72.06583000"
    },
    {
      "name": "Chandler",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.34935000",
      "longitude": "-64.67926000"
    },
    {
      "name": "Channel-Port aux Basques",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.57286000",
      "longitude": "-59.13808000"
    },
    {
      "name": "Chapais",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.78344000",
      "longitude": "-74.84919000"
    },
    {
      "name": "Charlemagne",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.71678000",
      "longitude": "-73.48247000"
    },
    {
      "name": "Charlottetown",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.23899000",
      "longitude": "-63.13414000"
    },
    {
      "name": "Chase",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.81650000",
      "longitude": "-119.68571000"
    },
    {
      "name": "Chatham",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.41224000",
      "longitude": "-82.18494000"
    },
    {
      "name": "Chatham-Kent",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.40009000",
      "longitude": "-82.18310000"
    },
    {
      "name": "Chaudière-Appalaches",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.55500000",
      "longitude": "-70.83080000"
    },
    {
      "name": "Chemainus",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.91633000",
      "longitude": "-123.71937000"
    },
    {
      "name": "Chertsey",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.07109000",
      "longitude": "-73.89095000"
    },
    {
      "name": "Chester",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.54225000",
      "longitude": "-64.23891000"
    },
    {
      "name": "Chestermere",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.03341000",
      "longitude": "-113.81867000"
    },
    {
      "name": "Chetwynd",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "55.69988000",
      "longitude": "-121.63627000"
    },
    {
      "name": "Chibougamau",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.91684000",
      "longitude": "-74.36586000"
    },
    {
      "name": "Chilliwack",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.16638000",
      "longitude": "-121.95257000"
    },
    {
      "name": "Chute-aux-Outardes",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.11679000",
      "longitude": "-68.39896000"
    },
    {
      "name": "Château-Richer",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.96031000",
      "longitude": "-71.03219000"
    },
    {
      "name": "Châteauguay",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.38338000",
      "longitude": "-73.74919000"
    },
    {
      "name": "Clarence-Rockland",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.55010000",
      "longitude": "-75.29101000"
    },
    {
      "name": "Clarenville-Shoal Harbour",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.18050000",
      "longitude": "-53.96982000"
    },
    {
      "name": "Claresholm",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.03332000",
      "longitude": "-113.58524000"
    },
    {
      "name": "Clyde River",
      "countryCode": "CA",
      "stateCode": "NU",
      "latitude": "70.47233000",
      "longitude": "-68.58987000"
    },
    {
      "name": "Coaldale",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.71670000",
      "longitude": "-112.61854000"
    },
    {
      "name": "Coalhurst",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.74640000",
      "longitude": "-112.93246000"
    },
    {
      "name": "Coaticook",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.13339000",
      "longitude": "-71.79907000"
    },
    {
      "name": "Cobourg",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.95977000",
      "longitude": "-78.16515000"
    },
    {
      "name": "Cochrane",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.18341000",
      "longitude": "-114.46871000"
    },
    {
      "name": "Cochrane District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "50.00022000",
      "longitude": "-82.99979000"
    },
    {
      "name": "Colchester",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.33345000",
      "longitude": "-63.24868000"
    },
    {
      "name": "Cold Lake",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.46525000",
      "longitude": "-110.18154000"
    },
    {
      "name": "Cole Harbour",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.67244000",
      "longitude": "-63.47506000"
    },
    {
      "name": "Collingwood",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.48340000",
      "longitude": "-80.21638000"
    },
    {
      "name": "Colwood",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.43293000",
      "longitude": "-123.48591000"
    },
    {
      "name": "Conception Bay South",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.49989000",
      "longitude": "-52.99806000"
    },
    {
      "name": "Concord",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.80011000",
      "longitude": "-79.48291000"
    },
    {
      "name": "Constance Bay",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.50011000",
      "longitude": "-76.08267000"
    },
    {
      "name": "Contrecoeur",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.85008000",
      "longitude": "-73.23245000"
    },
    {
      "name": "Cookshire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.41536000",
      "longitude": "-71.62962000"
    },
    {
      "name": "Cookshire-Eaton",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.41675000",
      "longitude": "-71.63240000"
    },
    {
      "name": "Cookstown",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.18341000",
      "longitude": "-79.69964000"
    },
    {
      "name": "Coombs",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.29963000",
      "longitude": "-124.41946000"
    },
    {
      "name": "Coquitlam",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.28460000",
      "longitude": "-122.78217000"
    },
    {
      "name": "Corner Brook",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.95001000",
      "longitude": "-57.95202000"
    },
    {
      "name": "Cornwall",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.01809000",
      "longitude": "-74.72815000"
    },
    {
      "name": "Cornwall",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.22652000",
      "longitude": "-63.21809000"
    },
    {
      "name": "Corunna",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.88338000",
      "longitude": "-82.43313000"
    },
    {
      "name": "Coteau-du-Lac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.30008000",
      "longitude": "-74.18253000"
    },
    {
      "name": "Courtenay",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.68657000",
      "longitude": "-124.99360000"
    },
    {
      "name": "Cow Bay",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.63141000",
      "longitude": "-63.43218000"
    },
    {
      "name": "Cowansville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.20008000",
      "longitude": "-72.74913000"
    },
    {
      "name": "Cowichan Bay",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.73366000",
      "longitude": "-123.61739000"
    },
    {
      "name": "Crabtree",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.96677000",
      "longitude": "-73.46586000"
    },
    {
      "name": "Cranbrook",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.49991000",
      "longitude": "-115.76879000"
    },
    {
      "name": "Creston",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.09987000",
      "longitude": "-116.50211000"
    },
    {
      "name": "Cross Lake 19A",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "54.65135000",
      "longitude": "-97.76848000"
    },
    {
      "name": "Crossfield",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.43341000",
      "longitude": "-114.03528000"
    },
    {
      "name": "Cumberland",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.61634000",
      "longitude": "-125.03613000"
    },
    {
      "name": "Côte-Nord",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "50.86683000",
      "longitude": "-65.81541000"
    },
    {
      "name": "Côte-Saint-Luc",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.46536000",
      "longitude": "-73.66585000"
    },
    {
      "name": "Dalmeny",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.33339000",
      "longitude": "-106.76792000"
    },
    {
      "name": "Danville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.78337000",
      "longitude": "-72.01580000"
    },
    {
      "name": "Dartmouth",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.67134000",
      "longitude": "-63.57719000"
    },
    {
      "name": "Dauphin",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "51.14941000",
      "longitude": "-100.05023000"
    },
    {
      "name": "Daveluyville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.20006000",
      "longitude": "-72.13239000"
    },
    {
      "name": "Dawson City",
      "countryCode": "CA",
      "stateCode": "YT",
      "latitude": "64.06013000",
      "longitude": "-139.43328000"
    },
    {
      "name": "Dawson Creek",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "55.75984000",
      "longitude": "-120.24030000"
    },
    {
      "name": "De Salaberry",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.39999000",
      "longitude": "-97.00894000"
    },
    {
      "name": "Deep River",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.10012000",
      "longitude": "-77.49949000"
    },
    {
      "name": "Deer Lake",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "49.16671000",
      "longitude": "-57.43163000"
    },
    {
      "name": "Delaware",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.91679000",
      "longitude": "-81.41646000"
    },
    {
      "name": "Deloraine",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.19082000",
      "longitude": "-100.49477000"
    },
    {
      "name": "Delson",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.36678000",
      "longitude": "-73.54917000"
    },
    {
      "name": "Delta",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.14399000",
      "longitude": "-122.90680000"
    },
    {
      "name": "Denman Island",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.53294000",
      "longitude": "-124.81950000"
    },
    {
      "name": "Denman Island Trust Area",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.55189000",
      "longitude": "-124.79881000"
    },
    {
      "name": "Deseronto",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.20012000",
      "longitude": "-77.04944000"
    },
    {
      "name": "Deux-Montagnes",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53455000",
      "longitude": "-73.90168000"
    },
    {
      "name": "Devon",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.36683000",
      "longitude": "-113.73533000"
    },
    {
      "name": "Didsbury",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.66681000",
      "longitude": "-114.13529000"
    },
    {
      "name": "Dieppe",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.07844000",
      "longitude": "-64.68735000"
    },
    {
      "name": "Digby",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.62188000",
      "longitude": "-65.75860000"
    },
    {
      "name": "Digby County",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.36685000",
      "longitude": "-65.69884000"
    },
    {
      "name": "Disraeli",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.90007000",
      "longitude": "-71.34907000"
    },
    {
      "name": "Dolbeau-Mistassini",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.87860000",
      "longitude": "-72.23142000"
    },
    {
      "name": "Dollard-Des Ormeaux",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.49452000",
      "longitude": "-73.82419000"
    },
    {
      "name": "Donnacona",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.68042000",
      "longitude": "-71.72390000"
    },
    {
      "name": "Dorchester",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.98339000",
      "longitude": "-81.06643000"
    },
    {
      "name": "Dorval",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.44730000",
      "longitude": "-73.75335000"
    },
    {
      "name": "Dowling",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.59111000",
      "longitude": "-81.33917000"
    },
    {
      "name": "Drayton Valley",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.21682000",
      "longitude": "-114.98544000"
    },
    {
      "name": "Drummondville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.88336000",
      "longitude": "-72.48241000"
    },
    {
      "name": "Dryden",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.78334000",
      "longitude": "-92.75032000"
    },
    {
      "name": "Duck Lake",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.00880000",
      "longitude": "-119.39672000"
    },
    {
      "name": "Duncan",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.78293000",
      "longitude": "-123.70266000"
    },
    {
      "name": "Dunham",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.13338000",
      "longitude": "-72.79913000"
    },
    {
      "name": "Durham",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.20012000",
      "longitude": "-78.99957000"
    },
    {
      "name": "Ear Falls",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "50.63955000",
      "longitude": "-93.23526000"
    },
    {
      "name": "East Angus",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.48338000",
      "longitude": "-71.66577000"
    },
    {
      "name": "East Broughton",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.21358000",
      "longitude": "-71.07674000"
    },
    {
      "name": "East Gwillimbury",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.10087000",
      "longitude": "-79.43785000"
    },
    {
      "name": "East Wellington",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.17385000",
      "longitude": "-124.01745000"
    },
    {
      "name": "East York",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.69053000",
      "longitude": "-79.32794000"
    },
    {
      "name": "Edmonton",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.55014000",
      "longitude": "-113.46871000"
    },
    {
      "name": "Edmundston",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.37370000",
      "longitude": "-68.32512000"
    },
    {
      "name": "Edson",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.58345000",
      "longitude": "-116.43559000"
    },
    {
      "name": "Elk Point",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.90017000",
      "longitude": "-110.90170000"
    },
    {
      "name": "Elkford",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.05007000",
      "longitude": "-114.88540000"
    },
    {
      "name": "Elliot Lake",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.38336000",
      "longitude": "-82.63315000"
    },
    {
      "name": "Ellison",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.93307000",
      "longitude": "-119.36907000"
    },
    {
      "name": "Elmvale",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.58340000",
      "longitude": "-79.86636000"
    },
    {
      "name": "Enderby",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.54980000",
      "longitude": "-119.15234000"
    },
    {
      "name": "Englehart",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "47.81686000",
      "longitude": "-79.86640000"
    },
    {
      "name": "English Corner",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.73345000",
      "longitude": "-63.78201000"
    },
    {
      "name": "Eskasoni 3",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.94522000",
      "longitude": "-60.61617000"
    },
    {
      "name": "Espanola",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.25837000",
      "longitude": "-81.76649000"
    },
    {
      "name": "Essex",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.17509000",
      "longitude": "-82.82483000"
    },
    {
      "name": "Esterhazy",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.65001000",
      "longitude": "-102.08426000"
    },
    {
      "name": "Estevan",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.13337000",
      "longitude": "-102.98422000"
    },
    {
      "name": "Etobicoke",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.65421000",
      "longitude": "-79.56711000"
    },
    {
      "name": "Fairview",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "56.06675000",
      "longitude": "-118.38606000"
    },
    {
      "name": "Fairwinds",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.27588000",
      "longitude": "-124.12782000"
    },
    {
      "name": "Falher",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.73339000",
      "longitude": "-117.20262000"
    },
    {
      "name": "Fall River",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.81685000",
      "longitude": "-63.61540000"
    },
    {
      "name": "Fallingbrook",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "45.47558000",
      "longitude": "-75.48401000"
    },
    {
      "name": "Farnham",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.28338000",
      "longitude": "-72.98244000"
    },
    {
      "name": "Ferme-Neuve",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.70011000",
      "longitude": "-75.44929000"
    },
    {
      "name": "Fermont",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "52.78345000",
      "longitude": "-67.08204000"
    },
    {
      "name": "Fernie",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.49996000",
      "longitude": "-115.06871000"
    },
    {
      "name": "Flin Flon",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "54.76703000",
      "longitude": "-101.87433000"
    },
    {
      "name": "Florenceville-Bristol",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.44353000",
      "longitude": "-67.61536000"
    },
    {
      "name": "Foam Lake",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.65001000",
      "longitude": "-103.53431000"
    },
    {
      "name": "Fogo Island",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "49.71649000",
      "longitude": "-54.16981000"
    },
    {
      "name": "Forestville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.73808000",
      "longitude": "-69.08478000"
    },
    {
      "name": "Fort Erie",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.90012000",
      "longitude": "-78.93286000"
    },
    {
      "name": "Fort Frances",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.61667000",
      "longitude": "-93.40030000"
    },
    {
      "name": "Fort Macleod",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.71671000",
      "longitude": "-113.41857000"
    },
    {
      "name": "Fort McMurray",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "56.72676000",
      "longitude": "-111.38103000"
    },
    {
      "name": "Fort McPherson",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "67.43863000",
      "longitude": "-134.88543000"
    },
    {
      "name": "Fort Nelson",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "58.80533000",
      "longitude": "-122.70020000"
    },
    {
      "name": "Fort Saskatchewan",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.71684000",
      "longitude": "-113.21870000"
    },
    {
      "name": "Fort Smith",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "60.00439000",
      "longitude": "-111.88871000"
    },
    {
      "name": "Fort St. John",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "56.24988000",
      "longitude": "-120.85292000"
    },
    {
      "name": "Fort-Coulonge",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.85011000",
      "longitude": "-76.73272000"
    },
    {
      "name": "Fossambault-sur-le-Lac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.87662000",
      "longitude": "-71.61541000"
    },
    {
      "name": "Fox Creek",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.40007000",
      "longitude": "-116.80238000"
    },
    {
      "name": "Franklin",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.03338000",
      "longitude": "-73.91591000"
    },
    {
      "name": "Fraser Valley Regional District",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.58299000",
      "longitude": "-121.83587000"
    },
    {
      "name": "Fredericton",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.94541000",
      "longitude": "-66.66558000"
    },
    {
      "name": "French Creek",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.34123000",
      "longitude": "-124.35541000"
    },
    {
      "name": "Fruitvale",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.11654000",
      "longitude": "-117.55222000"
    },
    {
      "name": "Fundy Bay",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "44.74100000",
      "longitude": "-66.76041000"
    },
    {
      "name": "Gambo",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.78320000",
      "longitude": "-54.21482000"
    },
    {
      "name": "Gananoque",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.33342000",
      "longitude": "-76.16607000"
    },
    {
      "name": "Gaspé",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.83341000",
      "longitude": "-64.48194000"
    },
    {
      "name": "Gaspésie-Îles-de-la-Madeleine",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.87555000",
      "longitude": "-65.40710000"
    },
    {
      "name": "Gatineau",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.47723000",
      "longitude": "-75.70164000"
    },
    {
      "name": "Gibbons",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.83345000",
      "longitude": "-113.33531000"
    },
    {
      "name": "Gibsons",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.39539000",
      "longitude": "-123.50555000"
    },
    {
      "name": "Gimli",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.63362000",
      "longitude": "-96.99066000"
    },
    {
      "name": "Gjoa Haven",
      "countryCode": "CA",
      "stateCode": "NU",
      "latitude": "68.62602000",
      "longitude": "-95.87836000"
    },
    {
      "name": "Glace Bay",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "46.19695000",
      "longitude": "-59.95698000"
    },
    {
      "name": "Glencoe",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.75009000",
      "longitude": "-81.71648000"
    },
    {
      "name": "Godefroy",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "51.75012000",
      "longitude": "-68.08213000"
    },
    {
      "name": "Goderich",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.74171000",
      "longitude": "-81.71339000"
    },
    {
      "name": "Golden",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "51.29995000",
      "longitude": "-116.96890000"
    },
    {
      "name": "Golden",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "51.05917000",
      "longitude": "-93.73568000"
    },
    {
      "name": "Goulds",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.45532000",
      "longitude": "-52.77552000"
    },
    {
      "name": "Granby",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.40008000",
      "longitude": "-72.73243000"
    },
    {
      "name": "Grand Bank",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.09995000",
      "longitude": "-55.76504000"
    },
    {
      "name": "Grand Centre",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.41628000",
      "longitude": "-110.21304000"
    },
    {
      "name": "Grand Falls-Windsor",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.93324000",
      "longitude": "-55.66492000"
    },
    {
      "name": "Grand Forks",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.03309000",
      "longitude": "-118.43560000"
    },
    {
      "name": "Grande Cache",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.88335000",
      "longitude": "-119.13585000"
    },
    {
      "name": "Grande Prairie",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.16667000",
      "longitude": "-118.80271000"
    },
    {
      "name": "Grande-Digue",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.30014000",
      "longitude": "-64.56546000"
    },
    {
      "name": "Gravelbourg",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.88336000",
      "longitude": "-106.55122000"
    },
    {
      "name": "Gravenhurst",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.91681000",
      "longitude": "-79.36633000"
    },
    {
      "name": "Greater Lakeburn",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.07651000",
      "longitude": "-64.66818000"
    },
    {
      "name": "Greater Napanee",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.25012000",
      "longitude": "-76.94944000"
    },
    {
      "name": "Greater Sudbury",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.49000000",
      "longitude": "-80.99001000"
    },
    {
      "name": "Greenstone",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.73343000",
      "longitude": "-87.16668000"
    },
    {
      "name": "Greenwood",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.97413000",
      "longitude": "-64.93169000"
    },
    {
      "name": "Grimshaw",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "56.18339000",
      "longitude": "-117.60270000"
    },
    {
      "name": "Grunthal",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.40668000",
      "longitude": "-96.85873000"
    },
    {
      "name": "Guelph",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.54594000",
      "longitude": "-80.25599000"
    },
    {
      "name": "Haines Junction",
      "countryCode": "CA",
      "stateCode": "YT",
      "latitude": "60.75216000",
      "longitude": "-137.51082000"
    },
    {
      "name": "Haldimand County",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.98341000",
      "longitude": "-79.86633000"
    },
    {
      "name": "Haliburton Village",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.05154000",
      "longitude": "-78.52245000"
    },
    {
      "name": "Halifax",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.64533000",
      "longitude": "-63.57239000"
    },
    {
      "name": "Halton",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.50011000",
      "longitude": "-79.88294000"
    },
    {
      "name": "Hamilton",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.25011000",
      "longitude": "-79.84963000"
    },
    {
      "name": "Hampstead",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.48064000",
      "longitude": "-73.66307000"
    },
    {
      "name": "Hampton",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.52876000",
      "longitude": "-65.85354000"
    },
    {
      "name": "Hanceville",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "51.91922000",
      "longitude": "-123.04458000"
    },
    {
      "name": "Hanna",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.63343000",
      "longitude": "-111.90181000"
    },
    {
      "name": "Hanover",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.15009000",
      "longitude": "-81.03303000"
    },
    {
      "name": "Hantsport",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.06685000",
      "longitude": "-64.16544000"
    },
    {
      "name": "Happy Valley-Goose Bay",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "53.30380000",
      "longitude": "-60.32576000"
    },
    {
      "name": "Harbour Breton",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.48325000",
      "longitude": "-55.79833000"
    },
    {
      "name": "Harrison Brook",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.21304000",
      "longitude": "-67.92847000"
    },
    {
      "name": "Harriston",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.90009000",
      "longitude": "-80.88302000"
    },
    {
      "name": "Hauterive",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.19572000",
      "longitude": "-68.25813000"
    },
    {
      "name": "Havre-Saint-Pierre",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "50.24342000",
      "longitude": "-63.60264000"
    },
    {
      "name": "Hawkesbury",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.60009000",
      "longitude": "-74.61595000"
    },
    {
      "name": "Hay River",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "60.81555000",
      "longitude": "-115.79993000"
    },
    {
      "name": "Hayes Subdivision",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.05519000",
      "longitude": "-64.58795000"
    },
    {
      "name": "Headingley",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.87530000",
      "longitude": "-97.40896000"
    },
    {
      "name": "Hearst",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.68351000",
      "longitude": "-83.66654000"
    },
    {
      "name": "Heritage Pointe",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.84213000",
      "longitude": "-114.00493000"
    },
    {
      "name": "High Level",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "58.51688000",
      "longitude": "-117.13605000"
    },
    {
      "name": "High Prairie",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.43340000",
      "longitude": "-116.48580000"
    },
    {
      "name": "High River",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.58341000",
      "longitude": "-113.86867000"
    },
    {
      "name": "Hinton",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.40009000",
      "longitude": "-117.58567000"
    },
    {
      "name": "Hope",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.38299000",
      "longitude": "-121.44144000"
    },
    {
      "name": "Hornby Island",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.53448000",
      "longitude": "-124.66923000"
    },
    {
      "name": "Hornepayne",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.21451000",
      "longitude": "-84.77617000"
    },
    {
      "name": "Houston",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.39976000",
      "longitude": "-126.67008000"
    },
    {
      "name": "Hudson",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.45008000",
      "longitude": "-74.14922000"
    },
    {
      "name": "Hudson Bay",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.85003000",
      "longitude": "-102.38425000"
    },
    {
      "name": "Humboldt",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.20005000",
      "longitude": "-105.12550000"
    },
    {
      "name": "Huntingdon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.08339000",
      "longitude": "-74.16593000"
    },
    {
      "name": "Huntsville",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.33341000",
      "longitude": "-79.21632000"
    },
    {
      "name": "Huron East",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.61679000",
      "longitude": "-81.29975000"
    },
    {
      "name": "Hérouxville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.66617000",
      "longitude": "-72.62512000"
    },
    {
      "name": "Ile des Chênes",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.71060000",
      "longitude": "-96.98893000"
    },
    {
      "name": "Indian Head",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.53336000",
      "longitude": "-103.66775000"
    },
    {
      "name": "Ingersoll",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.03339000",
      "longitude": "-80.88302000"
    },
    {
      "name": "Innisfil",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.30011000",
      "longitude": "-79.64964000"
    },
    {
      "name": "Inuvik",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "68.34986000",
      "longitude": "-133.72181000"
    },
    {
      "name": "Invermere",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.51666000",
      "longitude": "-116.03538000"
    },
    {
      "name": "Iqaluit",
      "countryCode": "CA",
      "stateCode": "NU",
      "latitude": "63.74697000",
      "longitude": "-68.51727000"
    },
    {
      "name": "Iroquois Falls",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.76688000",
      "longitude": "-80.68307000"
    },
    {
      "name": "Irricana",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.32372000",
      "longitude": "-113.60475000"
    },
    {
      "name": "Jarvis",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.88341000",
      "longitude": "-80.09965000"
    },
    {
      "name": "Jasper Park Lodge",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.88633000",
      "longitude": "-118.05625000"
    },
    {
      "name": "Joliette",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.01640000",
      "longitude": "-73.42360000"
    },
    {
      "name": "Jonquière",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.41648000",
      "longitude": "-71.24884000"
    },
    {
      "name": "Kamloops",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.66648000",
      "longitude": "-120.31920000"
    },
    {
      "name": "Kamsack",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.56668000",
      "longitude": "-101.90093000"
    },
    {
      "name": "Kanata",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.30010000",
      "longitude": "-75.91606000"
    },
    {
      "name": "Kapuskasing",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.41694000",
      "longitude": "-82.43308000"
    },
    {
      "name": "Kawartha Lakes",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.58342000",
      "longitude": "-78.83288000"
    },
    {
      "name": "Kelowna",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.88307000",
      "longitude": "-119.48568000"
    },
    {
      "name": "Kenora",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.76741000",
      "longitude": "-94.48985000"
    },
    {
      "name": "Kensington",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.43343000",
      "longitude": "-63.64871000"
    },
    {
      "name": "Kentville",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.07710000",
      "longitude": "-64.49605000"
    },
    {
      "name": "Kerrobert",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.91682000",
      "longitude": "-109.13479000"
    },
    {
      "name": "Keswick",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.25011000",
      "longitude": "-79.46632000"
    },
    {
      "name": "Keswick Ridge",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.00011000",
      "longitude": "-66.88218000"
    },
    {
      "name": "Killam",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.78344000",
      "longitude": "-111.85175000"
    },
    {
      "name": "Killarney",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.18332000",
      "longitude": "-99.66364000"
    },
    {
      "name": "Kimberley",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.67071000",
      "longitude": "-115.97760000"
    },
    {
      "name": "Kincardine",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.18339000",
      "longitude": "-81.63307000"
    },
    {
      "name": "Kindersley",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.46681000",
      "longitude": "-109.16818000"
    },
    {
      "name": "King",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.96514000",
      "longitude": "-79.59011000"
    },
    {
      "name": "Kingsey Falls",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.85007000",
      "longitude": "-72.06580000"
    },
    {
      "name": "Kingston",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.22976000",
      "longitude": "-76.48098000"
    },
    {
      "name": "Kirkland",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.45008000",
      "longitude": "-73.86586000"
    },
    {
      "name": "Kirkland Lake",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.14461000",
      "longitude": "-80.03767000"
    },
    {
      "name": "Kitchener",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.42537000",
      "longitude": "-80.51120000"
    },
    {
      "name": "Kitimat",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.05244000",
      "longitude": "-128.65342000"
    },
    {
      "name": "Kugluktuk",
      "countryCode": "CA",
      "stateCode": "NU",
      "latitude": "67.82743000",
      "longitude": "-115.09649000"
    },
    {
      "name": "L'Ancienne-Lorette",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.79392000",
      "longitude": "-71.35191000"
    },
    {
      "name": "L'Ange-Gardien",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.91976000",
      "longitude": "-71.08253000"
    },
    {
      "name": "L'Ascension-de-Notre-Seigneur",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.68339000",
      "longitude": "-71.66580000"
    },
    {
      "name": "L'Assomption",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.82318000",
      "longitude": "-73.42940000"
    },
    {
      "name": "L'Orignal",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.61980000",
      "longitude": "-74.69150000"
    },
    {
      "name": "L'Épiphanie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.85008000",
      "longitude": "-73.48246000"
    },
    {
      "name": "L'Île-Perrot",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.38338000",
      "longitude": "-73.94920000"
    },
    {
      "name": "La Broquerie",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.51688000",
      "longitude": "-96.50029000"
    },
    {
      "name": "La Conception",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.15009000",
      "longitude": "-74.69925000"
    },
    {
      "name": "La Haute-Saint-Charles",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.89028000",
      "longitude": "-71.37222000"
    },
    {
      "name": "La Malbaie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.65400000",
      "longitude": "-70.15268000"
    },
    {
      "name": "La Minerve",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.25009000",
      "longitude": "-74.93257000"
    },
    {
      "name": "La Pocatière",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.36733000",
      "longitude": "-70.03484000"
    },
    {
      "name": "La Prairie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.41678000",
      "longitude": "-73.49917000"
    },
    {
      "name": "La Ronge",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "55.10013000",
      "longitude": "-105.28422000"
    },
    {
      "name": "La Sarre",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.80019000",
      "longitude": "-79.19964000"
    },
    {
      "name": "La Tuque",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.43337000",
      "longitude": "-72.78240000"
    },
    {
      "name": "Labelle",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.28339000",
      "longitude": "-74.73255000"
    },
    {
      "name": "Labrador City",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "52.94626000",
      "longitude": "-66.91137000"
    },
    {
      "name": "Lac La Biche",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.76690000",
      "longitude": "-111.96861000"
    },
    {
      "name": "Lac du Bonnet",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.25360000",
      "longitude": "-96.06116000"
    },
    {
      "name": "Lac-Alouette",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.81698000",
      "longitude": "-73.95920000"
    },
    {
      "name": "Lac-Brome",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.21678000",
      "longitude": "-72.51581000"
    },
    {
      "name": "Lac-Connelly",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.89788000",
      "longitude": "-73.97230000"
    },
    {
      "name": "Lac-Lapierre",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.89837000",
      "longitude": "-73.77308000"
    },
    {
      "name": "Lac-Mégantic",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.58338000",
      "longitude": "-70.88234000"
    },
    {
      "name": "Lac-Simon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.15699000",
      "longitude": "-74.74129000"
    },
    {
      "name": "Lachute",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.65008000",
      "longitude": "-74.33253000"
    },
    {
      "name": "Lacolle",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.08338000",
      "longitude": "-73.36585000"
    },
    {
      "name": "Lacombe",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.46681000",
      "longitude": "-113.73530000"
    },
    {
      "name": "Ladner",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.08938000",
      "longitude": "-123.08241000"
    },
    {
      "name": "Ladysmith",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.99016000",
      "longitude": "-123.81699000"
    },
    {
      "name": "Lake Cowichan",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.82495000",
      "longitude": "-124.05461000"
    },
    {
      "name": "Lake Echo",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.73345000",
      "longitude": "-63.38198000"
    },
    {
      "name": "Lakefield",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.43342000",
      "longitude": "-78.26623000"
    },
    {
      "name": "Lambton Shores",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.16678000",
      "longitude": "-81.93309000"
    },
    {
      "name": "Lamont",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.76686000",
      "longitude": "-112.80195000"
    },
    {
      "name": "Landmark",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.67169000",
      "longitude": "-96.82232000"
    },
    {
      "name": "Langenburg",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.84999000",
      "longitude": "-101.71763000"
    },
    {
      "name": "Langford",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.44963000",
      "longitude": "-123.50261000"
    },
    {
      "name": "Langham",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.36680000",
      "longitude": "-106.96793000"
    },
    {
      "name": "Langley",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.10107000",
      "longitude": "-122.65883000"
    },
    {
      "name": "Lanigan",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.85006000",
      "longitude": "-105.03443000"
    },
    {
      "name": "Lanoraie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.96677000",
      "longitude": "-73.21585000"
    },
    {
      "name": "Lantz",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.98345000",
      "longitude": "-63.48199000"
    },
    {
      "name": "Lappe",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.56680000",
      "longitude": "-89.35013000"
    },
    {
      "name": "Larkspur",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.47942000",
      "longitude": "-113.38142000"
    },
    {
      "name": "Laurel",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.44667000",
      "longitude": "-113.38197000"
    },
    {
      "name": "Laval",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56995000",
      "longitude": "-73.69200000"
    },
    {
      "name": "Lavaltrie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.88338000",
      "longitude": "-73.28245000"
    },
    {
      "name": "Le Bic",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.37549000",
      "longitude": "-68.69415000"
    },
    {
      "name": "Leamington",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.05009000",
      "longitude": "-82.59981000"
    },
    {
      "name": "Lebel-sur-Quévillon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.05018000",
      "longitude": "-76.98273000"
    },
    {
      "name": "Leblanc",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.26683000",
      "longitude": "-74.34914000"
    },
    {
      "name": "Leduc",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.26682000",
      "longitude": "-113.55201000"
    },
    {
      "name": "Les Coteaux",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.28338000",
      "longitude": "-74.23254000"
    },
    {
      "name": "Les Cèdres",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.30008000",
      "longitude": "-74.04922000"
    },
    {
      "name": "Les Escoumins",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.35191000",
      "longitude": "-69.40724000"
    },
    {
      "name": "Lethbridge",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.69999000",
      "longitude": "-112.81856000"
    },
    {
      "name": "Lewisporte",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "49.24993000",
      "longitude": "-55.04816000"
    },
    {
      "name": "Lillooet",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.68560000",
      "longitude": "-121.94200000"
    },
    {
      "name": "Limoges",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.33340000",
      "longitude": "-75.24931000"
    },
    {
      "name": "Lincoln",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.90012000",
      "longitude": "-66.58218000"
    },
    {
      "name": "Lindsay",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.35012000",
      "longitude": "-78.73286000"
    },
    {
      "name": "Linière",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.00007000",
      "longitude": "-70.41572000"
    },
    {
      "name": "Lions Bay",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.45218000",
      "longitude": "-123.23760000"
    },
    {
      "name": "Listowel",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.73340000",
      "longitude": "-80.94973000"
    },
    {
      "name": "Little Current",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.97927000",
      "longitude": "-81.92480000"
    },
    {
      "name": "Lively",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.43338000",
      "longitude": "-81.14975000"
    },
    {
      "name": "Lloydminster",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.27237000",
      "longitude": "-110.02256000"
    },
    {
      "name": "Logan Lake",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.49976000",
      "longitude": "-120.80253000"
    },
    {
      "name": "London",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.98339000",
      "longitude": "-81.23304000"
    },
    {
      "name": "Longueuil",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53121000",
      "longitude": "-73.51806000"
    },
    {
      "name": "Lorette",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.73919000",
      "longitude": "-96.87232000"
    },
    {
      "name": "Lorraine",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.68338000",
      "longitude": "-73.78249000"
    },
    {
      "name": "Louiseville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.25594000",
      "longitude": "-72.94145000"
    },
    {
      "name": "Lower Sackville",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.77599000",
      "longitude": "-63.67865000"
    },
    {
      "name": "Lucan",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.18339000",
      "longitude": "-81.39976000"
    },
    {
      "name": "Luceville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.54498000",
      "longitude": "-68.39658000"
    },
    {
      "name": "Lumby",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.24979000",
      "longitude": "-118.96904000"
    },
    {
      "name": "Lumsden",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.65009000",
      "longitude": "-104.86783000"
    },
    {
      "name": "Lunenburg",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.37847000",
      "longitude": "-64.31658000"
    },
    {
      "name": "Lutes Mountain",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.13544000",
      "longitude": "-64.90504000"
    },
    {
      "name": "Lévis",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.80326000",
      "longitude": "-71.17793000"
    },
    {
      "name": "Macamic",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.75018000",
      "longitude": "-78.99962000"
    },
    {
      "name": "Mackenzie",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "55.33637000",
      "longitude": "-123.09374000"
    },
    {
      "name": "Macklin",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.33344000",
      "longitude": "-109.93484000"
    },
    {
      "name": "Madoc",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.50842000",
      "longitude": "-77.47448000"
    },
    {
      "name": "Magog",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.26678000",
      "longitude": "-72.14909000"
    },
    {
      "name": "Magrath",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.41668000",
      "longitude": "-112.86856000"
    },
    {
      "name": "Malartic",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.13348000",
      "longitude": "-78.13283000"
    },
    {
      "name": "Maliotenam",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "50.21119000",
      "longitude": "-66.18164000"
    },
    {
      "name": "Manawan",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.22029000",
      "longitude": "-74.38606000"
    },
    {
      "name": "Mandeville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.36677000",
      "longitude": "-73.34915000"
    },
    {
      "name": "Manitoulin District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.75007000",
      "longitude": "-82.49985000"
    },
    {
      "name": "Manitouwadge",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.12152000",
      "longitude": "-85.84030000"
    },
    {
      "name": "Maniwaki",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.38341000",
      "longitude": "-75.96605000"
    },
    {
      "name": "Manning",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "56.91683000",
      "longitude": "-117.61945000"
    },
    {
      "name": "Mannville",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.33764000",
      "longitude": "-111.17750000"
    },
    {
      "name": "Maple Creek",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.91678000",
      "longitude": "-109.48481000"
    },
    {
      "name": "Maple Ridge",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.21939000",
      "longitude": "-122.60193000"
    },
    {
      "name": "Maple Ridge",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.50172000",
      "longitude": "-113.36274000"
    },
    {
      "name": "Marathon",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.75010000",
      "longitude": "-86.43322000"
    },
    {
      "name": "Maria",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.17490000",
      "longitude": "-65.98595000"
    },
    {
      "name": "Marieville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.43338000",
      "longitude": "-73.16585000"
    },
    {
      "name": "Markdale",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.31680000",
      "longitude": "-80.64971000"
    },
    {
      "name": "Markham",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.86682000",
      "longitude": "-79.26630000"
    },
    {
      "name": "Martensville",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.28339000",
      "longitude": "-106.66792000"
    },
    {
      "name": "Marystown",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.16663000",
      "longitude": "-55.14829000"
    },
    {
      "name": "Mascouche",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.74965000",
      "longitude": "-73.59956000"
    },
    {
      "name": "Maskinongé",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.22860000",
      "longitude": "-73.01917000"
    },
    {
      "name": "Matagami",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.75018000",
      "longitude": "-77.63277000"
    },
    {
      "name": "Matane",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.82857000",
      "longitude": "-67.52197000"
    },
    {
      "name": "Mattawa",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.31681000",
      "longitude": "-78.69957000"
    },
    {
      "name": "Mauricie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.55009000",
      "longitude": "-73.41583000"
    },
    {
      "name": "Mayerthorpe",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.95015000",
      "longitude": "-115.13547000"
    },
    {
      "name": "McEwen",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.14520000",
      "longitude": "-64.78615000"
    },
    {
      "name": "Meadow Lake",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "54.13348000",
      "longitude": "-108.43471000"
    },
    {
      "name": "Meaford",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.60725000",
      "longitude": "-80.61081000"
    },
    {
      "name": "Medicine Hat",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.03928000",
      "longitude": "-110.67661000"
    },
    {
      "name": "Melfort",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.86673000",
      "longitude": "-104.61768000"
    },
    {
      "name": "Melita",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.26811000",
      "longitude": "-100.99669000"
    },
    {
      "name": "Melocheville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.31726000",
      "longitude": "-73.93710000"
    },
    {
      "name": "Melville",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.91671000",
      "longitude": "-102.80099000"
    },
    {
      "name": "Mercier",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.31678000",
      "longitude": "-73.74919000"
    },
    {
      "name": "Merritt",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.11225000",
      "longitude": "-120.79420000"
    },
    {
      "name": "Metabetchouan-Lac-a-la-Croix",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.41000000",
      "longitude": "-71.78000000"
    },
    {
      "name": "Metcalfe",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.23340000",
      "longitude": "-75.46603000"
    },
    {
      "name": "Metchosin",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.38293000",
      "longitude": "-123.53591000"
    },
    {
      "name": "Metro Vancouver Regional District",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.33296000",
      "longitude": "-123.00264000"
    },
    {
      "name": "Middleton",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.94284000",
      "longitude": "-65.07022000"
    },
    {
      "name": "Midland",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.75010000",
      "longitude": "-79.88296000"
    },
    {
      "name": "Mildmay",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.05009000",
      "longitude": "-81.11644000"
    },
    {
      "name": "Mill Woods Town Centre",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.45639000",
      "longitude": "-113.42751000"
    },
    {
      "name": "Millbrook",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.15012000",
      "longitude": "-78.44954000"
    },
    {
      "name": "Millet",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.10013000",
      "longitude": "-113.46870000"
    },
    {
      "name": "Milton",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.51681000",
      "longitude": "-79.88294000"
    },
    {
      "name": "Minnedosa",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.24532000",
      "longitude": "-99.84364000"
    },
    {
      "name": "Mirabel",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.65008000",
      "longitude": "-74.08251000"
    },
    {
      "name": "Miramichi",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.02895000",
      "longitude": "-65.50186000"
    },
    {
      "name": "Mission",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.13298000",
      "longitude": "-122.30258000"
    },
    {
      "name": "Mississauga",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.57890000",
      "longitude": "-79.65830000"
    },
    {
      "name": "Mississauga Beach",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.26682000",
      "longitude": "-79.08287000"
    },
    {
      "name": "Mistissini",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "50.41667000",
      "longitude": "-73.88333000"
    },
    {
      "name": "Moncton",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.09454000",
      "longitude": "-64.79650000"
    },
    {
      "name": "Mont-Joli",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.58388000",
      "longitude": "-68.19214000"
    },
    {
      "name": "Mont-Laurier",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.55011000",
      "longitude": "-75.49930000"
    },
    {
      "name": "Mont-Royal",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.51675000",
      "longitude": "-73.64918000"
    },
    {
      "name": "Mont-Saint-Grégoire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.33338000",
      "longitude": "-73.16585000"
    },
    {
      "name": "Mont-Saint-Hilaire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56515000",
      "longitude": "-73.18680000"
    },
    {
      "name": "Mont-Tremblant",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.21274000",
      "longitude": "-74.58438000"
    },
    {
      "name": "Montague",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.16681000",
      "longitude": "-62.64866000"
    },
    {
      "name": "Montmagny",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.98043000",
      "longitude": "-70.55493000"
    },
    {
      "name": "Montréal",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.50008000",
      "longitude": "-73.68248000"
    },
    {
      "name": "Montréal-Est",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.63202000",
      "longitude": "-73.50750000"
    },
    {
      "name": "Montréal-Ouest",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.45286000",
      "longitude": "-73.64918000"
    },
    {
      "name": "Moose Factory",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "51.26689000",
      "longitude": "-80.61624000"
    },
    {
      "name": "Moose Jaw",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.40005000",
      "longitude": "-105.53445000"
    },
    {
      "name": "Moose Lake",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.20559000",
      "longitude": "-95.30629000"
    },
    {
      "name": "Moosomin",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.13332000",
      "longitude": "-101.66766000"
    },
    {
      "name": "Moosonee",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "51.27931000",
      "longitude": "-80.63450000"
    },
    {
      "name": "Morden",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.19190000",
      "longitude": "-98.10136000"
    },
    {
      "name": "Morin-Heights",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.90009000",
      "longitude": "-74.24922000"
    },
    {
      "name": "Morinville",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.80014000",
      "longitude": "-113.65203000"
    },
    {
      "name": "Morris",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.35499000",
      "longitude": "-97.36567000"
    },
    {
      "name": "Morrisburg",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.90010000",
      "longitude": "-75.18261000"
    },
    {
      "name": "Mount Albert",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.13341000",
      "longitude": "-79.31630000"
    },
    {
      "name": "Mount Brydges",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.90009000",
      "longitude": "-81.48306000"
    },
    {
      "name": "Mount Pearl",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.51659000",
      "longitude": "-52.78135000"
    },
    {
      "name": "Métabetchouan",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.36679000",
      "longitude": "-72.01583000"
    },
    {
      "name": "Nackawic",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.99666000",
      "longitude": "-67.24028000"
    },
    {
      "name": "Nakusp",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.24987000",
      "longitude": "-117.80226000"
    },
    {
      "name": "Nanaimo",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.16638000",
      "longitude": "-123.94003000"
    },
    {
      "name": "Nanton",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.35008000",
      "longitude": "-113.76866000"
    },
    {
      "name": "Napanee",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.25012000",
      "longitude": "-76.94944000"
    },
    {
      "name": "Napanee Downtown",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.24832000",
      "longitude": "-76.95069000"
    },
    {
      "name": "Napierville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.18648000",
      "longitude": "-73.40468000"
    },
    {
      "name": "Neebing",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.16680000",
      "longitude": "-89.41683000"
    },
    {
      "name": "Neepawa",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.22892000",
      "longitude": "-99.46642000"
    },
    {
      "name": "Nelson",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.49985000",
      "longitude": "-117.28553000"
    },
    {
      "name": "Nepean",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.35215000",
      "longitude": "-75.73975000"
    },
    {
      "name": "Neuville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.69823000",
      "longitude": "-71.58275000"
    },
    {
      "name": "New Carlisle",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.00956000",
      "longitude": "-65.33621000"
    },
    {
      "name": "New Glasgow",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.58344000",
      "longitude": "-62.64863000"
    },
    {
      "name": "New Hamburg",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.38339000",
      "longitude": "-80.69970000"
    },
    {
      "name": "New Maryland",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.87932000",
      "longitude": "-66.66828000"
    },
    {
      "name": "New Westminster",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.20678000",
      "longitude": "-122.91092000"
    },
    {
      "name": "New-Richmond",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.16059000",
      "longitude": "-65.85823000"
    },
    {
      "name": "Newmarket",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.05011000",
      "longitude": "-79.46631000"
    },
    {
      "name": "Niagara Falls",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.10012000",
      "longitude": "-79.06627000"
    },
    {
      "name": "Nicolet",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.21676000",
      "longitude": "-72.61582000"
    },
    {
      "name": "Nipawin",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "53.36678000",
      "longitude": "-104.00092000"
    },
    {
      "name": "Nipissing District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.00010000",
      "longitude": "-78.99959000"
    },
    {
      "name": "Niverville",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.60559000",
      "longitude": "-97.04234000"
    },
    {
      "name": "Noonan",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.96682000",
      "longitude": "-66.53218000"
    },
    {
      "name": "Nord-du-Québec",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "51.96200000",
      "longitude": "-74.89610000"
    },
    {
      "name": "Norfolk County",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.83340000",
      "longitude": "-80.38297000"
    },
    {
      "name": "Norman Wells",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "65.28201000",
      "longitude": "-126.83290000"
    },
    {
      "name": "Normandin",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.83328000",
      "longitude": "-72.53209000"
    },
    {
      "name": "North Battleford",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.77972000",
      "longitude": "-108.29670000"
    },
    {
      "name": "North Bay",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.31680000",
      "longitude": "-79.46633000"
    },
    {
      "name": "North Cowichan",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.84133000",
      "longitude": "-123.68596000"
    },
    {
      "name": "North Oyster/Yellow Point",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.04807000",
      "longitude": "-123.83395000"
    },
    {
      "name": "North Perth",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.72510000",
      "longitude": "-80.96723000"
    },
    {
      "name": "North Saanich",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.66634000",
      "longitude": "-123.41933000"
    },
    {
      "name": "North Vancouver",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.31636000",
      "longitude": "-123.06934000"
    },
    {
      "name": "North York",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.76681000",
      "longitude": "-79.41630000"
    },
    {
      "name": "Norwood",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.38342000",
      "longitude": "-77.98281000"
    },
    {
      "name": "Notre-Dame-de-Grâce",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.47675000",
      "longitude": "-73.61432000"
    },
    {
      "name": "Notre-Dame-de-l'Île-Perrot",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.36678000",
      "longitude": "-73.93250000"
    },
    {
      "name": "Notre-Dame-des-Prairies",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.05007000",
      "longitude": "-73.43245000"
    },
    {
      "name": "Notre-Dame-du-Lac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.75012000",
      "longitude": "-79.04961000"
    },
    {
      "name": "Notre-Dame-du-Mont-Carmel",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.01680000",
      "longitude": "-75.08259000"
    },
    {
      "name": "Oak Bay",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.44964000",
      "longitude": "-123.30260000"
    },
    {
      "name": "Oakville",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.45011000",
      "longitude": "-79.68292000"
    },
    {
      "name": "Oka",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.46489000",
      "longitude": "-74.08892000"
    },
    {
      "name": "Okanagan",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.36386000",
      "longitude": "-119.34997000"
    },
    {
      "name": "Okanagan Falls",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.35000000",
      "longitude": "-119.56667000"
    },
    {
      "name": "Okotoks",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.72885000",
      "longitude": "-113.98281000"
    },
    {
      "name": "Olds",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.78341000",
      "longitude": "-114.10199000"
    },
    {
      "name": "Oliver",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.18306000",
      "longitude": "-119.55240000"
    },
    {
      "name": "Omemee",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.29897000",
      "longitude": "-78.55989000"
    },
    {
      "name": "Orangeville",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.91680000",
      "longitude": "-80.09967000"
    },
    {
      "name": "Orillia",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.60868000",
      "longitude": "-79.42068000"
    },
    {
      "name": "Ormstown",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.13338000",
      "longitude": "-73.99922000"
    },
    {
      "name": "Oromocto",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.83512000",
      "longitude": "-66.47917000"
    },
    {
      "name": "Osgoode",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.14887000",
      "longitude": "-75.59778000"
    },
    {
      "name": "Oshawa",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.90012000",
      "longitude": "-78.84957000"
    },
    {
      "name": "Osoyoos",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.03306000",
      "longitude": "-119.45237000"
    },
    {
      "name": "Ottawa",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.41117000",
      "longitude": "-75.69812000"
    },
    {
      "name": "Otterburn Park",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53338000",
      "longitude": "-73.21585000"
    },
    {
      "name": "Outaouais",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.26681000",
      "longitude": "-76.31606000"
    },
    {
      "name": "Outlook",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.50008000",
      "longitude": "-107.05128000"
    },
    {
      "name": "Owen Sound",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.56717000",
      "longitude": "-80.94349000"
    },
    {
      "name": "Oxbow",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.23335000",
      "longitude": "-102.16760000"
    },
    {
      "name": "Oxford",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.73345000",
      "longitude": "-63.86542000"
    },
    {
      "name": "Paisley",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.30641000",
      "longitude": "-81.27265000"
    },
    {
      "name": "Pangnirtung",
      "countryCode": "CA",
      "stateCode": "NU",
      "latitude": "66.14642000",
      "longitude": "-65.69996000"
    },
    {
      "name": "Papineauville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.61680000",
      "longitude": "-75.01599000"
    },
    {
      "name": "Parc-Boutin",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.29209000",
      "longitude": "-73.26154000"
    },
    {
      "name": "Paris",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.20000000",
      "longitude": "-80.38333000"
    },
    {
      "name": "Parkhill",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.15993000",
      "longitude": "-81.68464000"
    },
    {
      "name": "Parksville",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.31947000",
      "longitude": "-124.31575000"
    },
    {
      "name": "Parrsboro",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.40567000",
      "longitude": "-64.32585000"
    },
    {
      "name": "Parry Sound",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.34732000",
      "longitude": "-80.03527000"
    },
    {
      "name": "Parry Sound District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.75011000",
      "longitude": "-79.83297000"
    },
    {
      "name": "Pasadena",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "49.01671000",
      "longitude": "-57.59837000"
    },
    {
      "name": "Peace River",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "56.23715000",
      "longitude": "-117.29176000"
    },
    {
      "name": "Peace River Regional District",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "56.66650000",
      "longitude": "-122.75302000"
    },
    {
      "name": "Peachland",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.76647000",
      "longitude": "-119.73568000"
    },
    {
      "name": "Peel",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.75011000",
      "longitude": "-79.78293000"
    },
    {
      "name": "Pelican Narrows",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "55.16685000",
      "longitude": "-102.93410000"
    },
    {
      "name": "Pemberton",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.31641000",
      "longitude": "-122.80273000"
    },
    {
      "name": "Pembroke",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.81681000",
      "longitude": "-77.11616000"
    },
    {
      "name": "Penhold",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.13342000",
      "longitude": "-113.86870000"
    },
    {
      "name": "Penticton",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.48062000",
      "longitude": "-119.58584000"
    },
    {
      "name": "Perth",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.90011000",
      "longitude": "-76.24939000"
    },
    {
      "name": "Petawawa",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.89452000",
      "longitude": "-77.28007000"
    },
    {
      "name": "Peterborough",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.30012000",
      "longitude": "-78.31623000"
    },
    {
      "name": "Petrolia",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.86678000",
      "longitude": "-82.14981000"
    },
    {
      "name": "Pickering",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.90012000",
      "longitude": "-79.13289000"
    },
    {
      "name": "Picton",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.00012000",
      "longitude": "-77.13275000"
    },
    {
      "name": "Pictou",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.67875000",
      "longitude": "-62.70936000"
    },
    {
      "name": "Pictou County",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.50015000",
      "longitude": "-62.58193000"
    },
    {
      "name": "Picture Butte",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.88330000",
      "longitude": "-112.78516000"
    },
    {
      "name": "Piedmont",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.90008000",
      "longitude": "-74.13251000"
    },
    {
      "name": "Pierreville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.07034000",
      "longitude": "-72.81125000"
    },
    {
      "name": "Pilot Butte",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.46678000",
      "longitude": "-104.41778000"
    },
    {
      "name": "Pincher Creek",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.48328000",
      "longitude": "-113.95195000"
    },
    {
      "name": "Pincourt",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.38338000",
      "longitude": "-73.98250000"
    },
    {
      "name": "Pitt Meadows",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.22119000",
      "longitude": "-122.68965000"
    },
    {
      "name": "Plantagenet",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.53260000",
      "longitude": "-74.99369000"
    },
    {
      "name": "Plattsville",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.30010000",
      "longitude": "-80.61639000"
    },
    {
      "name": "Plessisville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.21856000",
      "longitude": "-71.76201000"
    },
    {
      "name": "Pohénégamook",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.46315000",
      "longitude": "-69.22666000"
    },
    {
      "name": "Pointe-Calumet",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.50008000",
      "longitude": "-73.96590000"
    },
    {
      "name": "Pointe-Claire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.44868000",
      "longitude": "-73.81669000"
    },
    {
      "name": "Pointe-du-Lac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.50009000",
      "longitude": "-71.78241000"
    },
    {
      "name": "Ponoka",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.67680000",
      "longitude": "-113.58147000"
    },
    {
      "name": "Pont Rouge",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.88332000",
      "longitude": "-72.08247000"
    },
    {
      "name": "Pont-Rouge",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.75468000",
      "longitude": "-71.69566000"
    },
    {
      "name": "Port Alberni",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.24133000",
      "longitude": "-124.80280000"
    },
    {
      "name": "Port Colborne",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.90012000",
      "longitude": "-79.23288000"
    },
    {
      "name": "Port Coquitlam",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.26637000",
      "longitude": "-122.76932000"
    },
    {
      "name": "Port Hawkesbury",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.61685000",
      "longitude": "-61.34853000"
    },
    {
      "name": "Port Hope",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.01682000",
      "longitude": "-78.39953000"
    },
    {
      "name": "Port McNeill",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.58716000",
      "longitude": "-127.08053000"
    },
    {
      "name": "Port Moody",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.28124000",
      "longitude": "-122.82457000"
    },
    {
      "name": "Port Rowan",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.61680000",
      "longitude": "-80.46638000"
    },
    {
      "name": "Port Stanley",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.66679000",
      "longitude": "-81.21644000"
    },
    {
      "name": "Port Williams",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.10015000",
      "longitude": "-64.41546000"
    },
    {
      "name": "Port-Cartier",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "50.03339000",
      "longitude": "-66.86545000"
    },
    {
      "name": "Portage la Prairie",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.97282000",
      "longitude": "-98.29263000"
    },
    {
      "name": "Portneuf",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.69058000",
      "longitude": "-71.89011000"
    },
    {
      "name": "Powassan",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.03340000",
      "longitude": "-79.34961000"
    },
    {
      "name": "Powell River",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.83278000",
      "longitude": "-124.52368000"
    },
    {
      "name": "Preeceville",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.94998000",
      "longitude": "-102.66766000"
    },
    {
      "name": "Prescott",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.71681000",
      "longitude": "-75.51604000"
    },
    {
      "name": "Prince Albert",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "53.20008000",
      "longitude": "-105.76772000"
    },
    {
      "name": "Prince Edward",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.00012000",
      "longitude": "-77.24946000"
    },
    {
      "name": "Prince George",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "53.91660000",
      "longitude": "-122.75301000"
    },
    {
      "name": "Prince Rupert",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.31507000",
      "longitude": "-130.32098000"
    },
    {
      "name": "Princeton",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.45802000",
      "longitude": "-120.51076000"
    },
    {
      "name": "Princeville",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.76684000",
      "longitude": "-61.29853000"
    },
    {
      "name": "Princeville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.17163000",
      "longitude": "-71.87462000"
    },
    {
      "name": "Provost",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.35014000",
      "longitude": "-110.26828000"
    },
    {
      "name": "Prévost",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.86678000",
      "longitude": "-74.08251000"
    },
    {
      "name": "Puntledge",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.66168000",
      "longitude": "-125.05686000"
    },
    {
      "name": "Queenswood Heights",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.47083000",
      "longitude": "-75.50556000"
    },
    {
      "name": "Quesnel",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "52.97842000",
      "longitude": "-122.49310000"
    },
    {
      "name": "Quinte West",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.18342000",
      "longitude": "-77.56618000"
    },
    {
      "name": "Québec",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.81228000",
      "longitude": "-71.21454000"
    },
    {
      "name": "Rainy River District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.49981000",
      "longitude": "-92.50031000"
    },
    {
      "name": "Rankin Inlet",
      "countryCode": "CA",
      "stateCode": "NU",
      "latitude": "62.80906000",
      "longitude": "-92.08534000"
    },
    {
      "name": "Rawdon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.05007000",
      "longitude": "-73.71587000"
    },
    {
      "name": "Raymond",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.44998000",
      "longitude": "-112.65185000"
    },
    {
      "name": "Rayside-Balfour",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.60873000",
      "longitude": "-81.20763000"
    },
    {
      "name": "Red Deer",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.26682000",
      "longitude": "-113.80200000"
    },
    {
      "name": "Red Lake",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "51.01678000",
      "longitude": "-93.82736000"
    },
    {
      "name": "Regina",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.45008000",
      "longitude": "-104.61780000"
    },
    {
      "name": "Regina Beach",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.78338000",
      "longitude": "-105.00112000"
    },
    {
      "name": "Regional District of Alberni-Clayoquot",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.24962000",
      "longitude": "-125.33615000"
    },
    {
      "name": "Regional District of Central Okanagan",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.99978000",
      "longitude": "-119.41908000"
    },
    {
      "name": "Regional Municipality of Waterloo",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.50010000",
      "longitude": "-80.49969000"
    },
    {
      "name": "Renfrew",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.46681000",
      "longitude": "-76.68272000"
    },
    {
      "name": "Repentigny",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.74222000",
      "longitude": "-73.45008000"
    },
    {
      "name": "Revelstoke",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.99712000",
      "longitude": "-118.19530000"
    },
    {
      "name": "Richelieu",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.44336000",
      "longitude": "-73.24602000"
    },
    {
      "name": "Richibucto",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.68073000",
      "longitude": "-64.88044000"
    },
    {
      "name": "Richmond",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.17003000",
      "longitude": "-123.13683000"
    },
    {
      "name": "Richmond",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.66677000",
      "longitude": "-72.14910000"
    },
    {
      "name": "Richmond",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.18340000",
      "longitude": "-75.83266000"
    },
    {
      "name": "Richmond Hill",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.87111000",
      "longitude": "-79.43725000"
    },
    {
      "name": "Rideau Park",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.47899000",
      "longitude": "-113.50470000"
    },
    {
      "name": "Ridgetown",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.43339000",
      "longitude": "-81.89978000"
    },
    {
      "name": "Rigaud",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.47927000",
      "longitude": "-74.30238000"
    },
    {
      "name": "Rimbey",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.63340000",
      "longitude": "-114.23532000"
    },
    {
      "name": "Rimouski",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.44879000",
      "longitude": "-68.52396000"
    },
    {
      "name": "Rivers",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.03081000",
      "longitude": "-100.24029000"
    },
    {
      "name": "Rivière-Rouge",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.41679000",
      "longitude": "-74.86596000"
    },
    {
      "name": "Rivière-du-Loup",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.82699000",
      "longitude": "-69.54243000"
    },
    {
      "name": "Roberval",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.51680000",
      "longitude": "-72.23244000"
    },
    {
      "name": "Roblin",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "51.22999000",
      "longitude": "-101.35650000"
    },
    {
      "name": "Rock Forest",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.35699000",
      "longitude": "-71.99676000"
    },
    {
      "name": "Rockwood",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.61899000",
      "longitude": "-80.14441000"
    },
    {
      "name": "Rocky Mountain House",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.36683000",
      "longitude": "-114.91880000"
    },
    {
      "name": "Rosemère",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.63338000",
      "longitude": "-73.79919000"
    },
    {
      "name": "Rosetown",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.55010000",
      "longitude": "-108.00136000"
    },
    {
      "name": "Rossland",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.08313000",
      "longitude": "-117.80224000"
    },
    {
      "name": "Rosthern",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.66679000",
      "longitude": "-106.33446000"
    },
    {
      "name": "Rougemont",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.43338000",
      "longitude": "-73.04914000"
    },
    {
      "name": "Rouyn-Noranda",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.23656000",
      "longitude": "-79.02311000"
    },
    {
      "name": "Royston",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.64703000",
      "longitude": "-124.94670000"
    },
    {
      "name": "Russell",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.25010000",
      "longitude": "-75.36602000"
    },
    {
      "name": "Sackville",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.91875000",
      "longitude": "-64.38455000"
    },
    {
      "name": "Sacré-Coeur",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.22970000",
      "longitude": "-69.80061000"
    },
    {
      "name": "Saguenay",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.41675000",
      "longitude": "-71.06573000"
    },
    {
      "name": "Saint Andrews",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.07370000",
      "longitude": "-67.05312000"
    },
    {
      "name": "Saint John",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.27271000",
      "longitude": "-66.06766000"
    },
    {
      "name": "Saint-Adolphe-d'Howard",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.96679000",
      "longitude": "-74.33253000"
    },
    {
      "name": "Saint-Alexandre",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.50010000",
      "longitude": "-75.74935000"
    },
    {
      "name": "Saint-Amable",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.65008000",
      "longitude": "-73.29916000"
    },
    {
      "name": "Saint-Ambroise",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.55009000",
      "longitude": "-71.33238000"
    },
    {
      "name": "Saint-André-Avellin",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.71680000",
      "longitude": "-75.06599000"
    },
    {
      "name": "Saint-Anselme",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.62922000",
      "longitude": "-70.97340000"
    },
    {
      "name": "Saint-Antoine",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.36294000",
      "longitude": "-64.74985000"
    },
    {
      "name": "Saint-Antoine-de-Tilly",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.66346000",
      "longitude": "-71.57335000"
    },
    {
      "name": "Saint-Augustin",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "51.22602000",
      "longitude": "-58.65017000"
    },
    {
      "name": "Saint-Augustin-de-Desmaures",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.74064000",
      "longitude": "-71.45131000"
    },
    {
      "name": "Saint-Barnabé-Sud",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.72977000",
      "longitude": "-72.92244000"
    },
    {
      "name": "Saint-Basile-le-Grand",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53338000",
      "longitude": "-73.28246000"
    },
    {
      "name": "Saint-Boniface",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.50011000",
      "longitude": "-75.98264000"
    },
    {
      "name": "Saint-Bruno",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.46679000",
      "longitude": "-71.64910000"
    },
    {
      "name": "Saint-Bruno-de-Guigues",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.46685000",
      "longitude": "-79.43296000"
    },
    {
      "name": "Saint-Bruno-de-Montarville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53341000",
      "longitude": "-73.34916000"
    },
    {
      "name": "Saint-Canut",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.71502000",
      "longitude": "-74.08376000"
    },
    {
      "name": "Saint-Charles",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.70288000",
      "longitude": "-73.55417000"
    },
    {
      "name": "Saint-Constant",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.36678000",
      "longitude": "-73.56588000"
    },
    {
      "name": "Saint-Cyrille-de-Wendover",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.93336000",
      "longitude": "-72.43241000"
    },
    {
      "name": "Saint-Césaire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.41678000",
      "longitude": "-72.99914000"
    },
    {
      "name": "Saint-Côme--Linière",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.06677000",
      "longitude": "-70.51573000"
    },
    {
      "name": "Saint-Damase",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53341000",
      "longitude": "-72.99914000"
    },
    {
      "name": "Saint-Denis-sur-Richelieu",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.78338000",
      "longitude": "-73.14915000"
    },
    {
      "name": "Saint-Donat-de-Montcalm",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.31868000",
      "longitude": "-74.22171000"
    },
    {
      "name": "Saint-Elzéar",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.60338000",
      "longitude": "-73.72698000"
    },
    {
      "name": "Saint-Eustache",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56500000",
      "longitude": "-73.90554000"
    },
    {
      "name": "Saint-Félicien",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.65007000",
      "longitude": "-72.44906000"
    },
    {
      "name": "Saint-Félix-de-Valois",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.16977000",
      "longitude": "-73.42525000"
    },
    {
      "name": "Saint-Gabriel",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.30007000",
      "longitude": "-73.38245000"
    },
    {
      "name": "Saint-Georges",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.11353000",
      "longitude": "-70.66526000"
    },
    {
      "name": "Saint-Germain-de-Grantham",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.83337000",
      "longitude": "-72.56582000"
    },
    {
      "name": "Saint-Gédéon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.50009000",
      "longitude": "-71.76581000"
    },
    {
      "name": "Saint-Henri",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.69314000",
      "longitude": "-71.06927000"
    },
    {
      "name": "Saint-Hippolyte",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.93338000",
      "longitude": "-74.01590000"
    },
    {
      "name": "Saint-Honoré",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.53338000",
      "longitude": "-71.08236000"
    },
    {
      "name": "Saint-Hyacinthe",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.63076000",
      "longitude": "-72.95699000"
    },
    {
      "name": "Saint-Isidore",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.43345000",
      "longitude": "-79.29965000"
    },
    {
      "name": "Saint-Jacques-le-Mineur",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.28338000",
      "longitude": "-73.41587000"
    },
    {
      "name": "Saint-Jean-Baptiste",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.38060000",
      "longitude": "-74.01210000"
    },
    {
      "name": "Saint-Jean-sur-Richelieu",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.30713000",
      "longitude": "-73.26259000"
    },
    {
      "name": "Saint-Joseph",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.95817000",
      "longitude": "-73.22025000"
    },
    {
      "name": "Saint-Joseph-de-Beauce",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.30000000",
      "longitude": "-70.86667000"
    },
    {
      "name": "Saint-Joseph-de-Coleraine",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.96677000",
      "longitude": "-71.36577000"
    },
    {
      "name": "Saint-Joseph-du-Lac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53338000",
      "longitude": "-73.99920000"
    },
    {
      "name": "Saint-Jérôme",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.78036000",
      "longitude": "-74.00365000"
    },
    {
      "name": "Saint-Lambert-de-Lauzon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.58624000",
      "longitude": "-71.20892000"
    },
    {
      "name": "Saint-Laurent",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.50008000",
      "longitude": "-73.66585000"
    },
    {
      "name": "Saint-Lazare",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.40008000",
      "longitude": "-74.13256000"
    },
    {
      "name": "Saint-Liboire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.65068000",
      "longitude": "-72.76348000"
    },
    {
      "name": "Saint-Lin-Laurentides",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.85008000",
      "longitude": "-73.76588000"
    },
    {
      "name": "Saint-Léonard",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.58773000",
      "longitude": "-73.59501000"
    },
    {
      "name": "Saint-Léonard",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.16317000",
      "longitude": "-67.92460000"
    },
    {
      "name": "Saint-Léonard-d'Aston",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.10006000",
      "longitude": "-72.36580000"
    },
    {
      "name": "Saint-Marc-des-Carrières",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.68335000",
      "longitude": "-72.04910000"
    },
    {
      "name": "Saint-Mathieu",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.31678000",
      "longitude": "-73.51587000"
    },
    {
      "name": "Saint-Michel",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56758000",
      "longitude": "-73.62168000"
    },
    {
      "name": "Saint-Michel-des-Saints",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.67702000",
      "longitude": "-73.91881000"
    },
    {
      "name": "Saint-Nazaire",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.58944000",
      "longitude": "-71.55247000"
    },
    {
      "name": "Saint-Norbert",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.16949000",
      "longitude": "-73.31494000"
    },
    {
      "name": "Saint-Pacôme",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.40457000",
      "longitude": "-69.95025000"
    },
    {
      "name": "Saint-Pascal",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.51813000",
      "longitude": "-69.80301000"
    },
    {
      "name": "Saint-Philippe-de-La Prairie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.35723000",
      "longitude": "-73.47706000"
    },
    {
      "name": "Saint-Pie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.50277000",
      "longitude": "-72.90890000"
    },
    {
      "name": "Saint-Pierre-les-Becquets",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.50005000",
      "longitude": "-72.19910000"
    },
    {
      "name": "Saint-Prime",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.58339000",
      "longitude": "-72.33244000"
    },
    {
      "name": "Saint-Raphaël",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.25011000",
      "longitude": "-76.01605000"
    },
    {
      "name": "Saint-Raymond",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.46698000",
      "longitude": "-73.60948000"
    },
    {
      "name": "Saint-Rémi",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.26678000",
      "longitude": "-73.61588000"
    },
    {
      "name": "Saint-Rémi-de-Tingwick",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.86677000",
      "longitude": "-71.81581000"
    },
    {
      "name": "Saint-Sauveur",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.88686000",
      "longitude": "-74.17943000"
    },
    {
      "name": "Saint-Sauveur-des-Monts",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.90008000",
      "longitude": "-74.16591000"
    },
    {
      "name": "Saint-Siméon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.84431000",
      "longitude": "-69.87837000"
    },
    {
      "name": "Saint-Thomas",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.01677000",
      "longitude": "-73.34915000"
    },
    {
      "name": "Saint-Tite",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.73336000",
      "longitude": "-72.56581000"
    },
    {
      "name": "Saint-Victor",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.61118000",
      "longitude": "-73.51527000"
    },
    {
      "name": "Saint-Zotique",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.25009000",
      "longitude": "-74.24924000"
    },
    {
      "name": "Saint-Édouard",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.23338000",
      "longitude": "-73.51588000"
    },
    {
      "name": "Saint-Éphrem-de-Beauce",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.06677000",
      "longitude": "-70.94905000"
    },
    {
      "name": "Sainte Catherine de la Jacques Cartier",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.85244000",
      "longitude": "-71.62056000"
    },
    {
      "name": "Sainte-Adèle",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.95008000",
      "longitude": "-74.13251000"
    },
    {
      "name": "Sainte-Agathe-des-Monts",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.05009000",
      "longitude": "-74.28252000"
    },
    {
      "name": "Sainte-Anne-de-Bellevue",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.40618000",
      "longitude": "-73.94560000"
    },
    {
      "name": "Sainte-Anne-des-Monts",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.12402000",
      "longitude": "-66.49243000"
    },
    {
      "name": "Sainte-Anne-des-Plaines",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.76468000",
      "longitude": "-73.81156000"
    },
    {
      "name": "Sainte-Béatrix",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.20007000",
      "longitude": "-73.61587000"
    },
    {
      "name": "Sainte-Catherine",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.40008000",
      "longitude": "-73.58248000"
    },
    {
      "name": "Sainte-Croix",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.13368000",
      "longitude": "-72.80083000"
    },
    {
      "name": "Sainte-Julie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.58338000",
      "longitude": "-73.33246000"
    },
    {
      "name": "Sainte-Julienne",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.96677000",
      "longitude": "-73.71587000"
    },
    {
      "name": "Sainte-Madeleine",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.60008000",
      "longitude": "-73.09914000"
    },
    {
      "name": "Sainte-Marie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.43401000",
      "longitude": "-71.01168000"
    },
    {
      "name": "Sainte-Marthe-sur-le-Lac",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.53338000",
      "longitude": "-73.93250000"
    },
    {
      "name": "Sainte-Martine",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.25008000",
      "longitude": "-73.79919000"
    },
    {
      "name": "Sainte-Sophie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.81678000",
      "longitude": "-73.89919000"
    },
    {
      "name": "Sainte-Thècle",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.81676000",
      "longitude": "-72.49911000"
    },
    {
      "name": "Sainte-Thérèse",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.63922000",
      "longitude": "-73.82757000"
    },
    {
      "name": "Sainte-Élisabeth",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.09502000",
      "longitude": "-73.35176000"
    },
    {
      "name": "Salaberry-de-Valleyfield",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.25008000",
      "longitude": "-74.13253000"
    },
    {
      "name": "Salisbury",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.03905000",
      "longitude": "-65.04628000"
    },
    {
      "name": "Salluit",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "62.20411000",
      "longitude": "-75.64344000"
    },
    {
      "name": "Salmo",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.19986000",
      "longitude": "-117.26890000"
    },
    {
      "name": "Salmon Arm",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.69980000",
      "longitude": "-119.30237000"
    },
    {
      "name": "Salt Spring Island",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.81852000",
      "longitude": "-123.49061000"
    },
    {
      "name": "Saltair",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.94963000",
      "longitude": "-123.76939000"
    },
    {
      "name": "Sarnia",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.97866000",
      "longitude": "-82.40407000"
    },
    {
      "name": "Saskatoon",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.13238000",
      "longitude": "-106.66892000"
    },
    {
      "name": "Sault Ste. Marie",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.51677000",
      "longitude": "-84.33325000"
    },
    {
      "name": "Scarborough",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.77223000",
      "longitude": "-79.25666000"
    },
    {
      "name": "Seaforth",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.55009000",
      "longitude": "-81.39976000"
    },
    {
      "name": "Sechelt",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.47512000",
      "longitude": "-123.75903000"
    },
    {
      "name": "Selkirk",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.14360000",
      "longitude": "-96.88452000"
    },
    {
      "name": "Senneterre",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.39302000",
      "longitude": "-77.23951000"
    },
    {
      "name": "Sept-Îles",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "50.20011000",
      "longitude": "-66.38208000"
    },
    {
      "name": "Sexsmith",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.34998000",
      "longitude": "-118.78602000"
    },
    {
      "name": "Shannon",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.88026000",
      "longitude": "-71.51464000"
    },
    {
      "name": "Shaunavon",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.65005000",
      "longitude": "-108.41810000"
    },
    {
      "name": "Shawinigan",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.56675000",
      "longitude": "-72.74913000"
    },
    {
      "name": "Shawville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.60011000",
      "longitude": "-76.48270000"
    },
    {
      "name": "Shediac",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.21981000",
      "longitude": "-64.54107000"
    },
    {
      "name": "Shediac Bridge-Shediac River",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "46.26886000",
      "longitude": "-64.60047000"
    },
    {
      "name": "Shelburne",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.07870000",
      "longitude": "-80.20408000"
    },
    {
      "name": "Shelburne",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "43.76325000",
      "longitude": "-65.32355000"
    },
    {
      "name": "Shellbrook",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "53.21679000",
      "longitude": "-106.40109000"
    },
    {
      "name": "Sherbrooke",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.40008000",
      "longitude": "-71.89908000"
    },
    {
      "name": "Sherwood Park",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.51684000",
      "longitude": "-113.31870000"
    },
    {
      "name": "Shilo",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.80509000",
      "longitude": "-99.63175000"
    },
    {
      "name": "Shippagan",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.74424000",
      "longitude": "-64.70804000"
    },
    {
      "name": "Sicamous",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.83312000",
      "longitude": "-118.98565000"
    },
    {
      "name": "Silver Berry",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.45787000",
      "longitude": "-113.38170000"
    },
    {
      "name": "Simcoe",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.83340000",
      "longitude": "-80.29967000"
    },
    {
      "name": "Sioux Lookout",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "50.06676000",
      "longitude": "-91.98358000"
    },
    {
      "name": "Six Mile",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.45767000",
      "longitude": "-123.46088000"
    },
    {
      "name": "Skatepark",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.25122000",
      "longitude": "-76.94424000"
    },
    {
      "name": "Slave Lake",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.28344000",
      "longitude": "-114.76896000"
    },
    {
      "name": "Smithers",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.78036000",
      "longitude": "-127.17428000"
    },
    {
      "name": "Smiths Falls",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.90452000",
      "longitude": "-76.02333000"
    },
    {
      "name": "Smoky Lake",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.11687000",
      "longitude": "-112.46863000"
    },
    {
      "name": "Sooke",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.37463000",
      "longitude": "-123.72762000"
    },
    {
      "name": "Sorel-Tracy",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.04178000",
      "longitude": "-73.11358000"
    },
    {
      "name": "Souris",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.35010000",
      "longitude": "-62.24862000"
    },
    {
      "name": "Souris",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.61720000",
      "longitude": "-100.26120000"
    },
    {
      "name": "South Huron",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.31679000",
      "longitude": "-81.51647000"
    },
    {
      "name": "South Pender Harbour",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.62202000",
      "longitude": "-124.02484000"
    },
    {
      "name": "South River",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.83340000",
      "longitude": "-79.38293000"
    },
    {
      "name": "Sparwood",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.73332000",
      "longitude": "-114.88532000"
    },
    {
      "name": "Spirit River",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.78327000",
      "longitude": "-118.83607000"
    },
    {
      "name": "Springbrook",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.17920000",
      "longitude": "-113.87981000"
    },
    {
      "name": "Springdale",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "49.49995000",
      "longitude": "-56.06492000"
    },
    {
      "name": "Springhill",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.65015000",
      "longitude": "-64.04873000"
    },
    {
      "name": "Spruce Grove",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.53344000",
      "longitude": "-113.91874000"
    },
    {
      "name": "St-Jean-Port-Joli",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.21418000",
      "longitude": "-70.26969000"
    },
    {
      "name": "St. Adolphe",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.67440000",
      "longitude": "-97.11124000"
    },
    {
      "name": "St. Albert",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.63344000",
      "longitude": "-113.63533000"
    },
    {
      "name": "St. Anthony",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "51.37039000",
      "longitude": "-55.59743000"
    },
    {
      "name": "St. Catharines",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.17126000",
      "longitude": "-79.24267000"
    },
    {
      "name": "St. George",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.24495000",
      "longitude": "-80.25144000"
    },
    {
      "name": "St. John's",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.56494000",
      "longitude": "-52.70931000"
    },
    {
      "name": "St. Thomas",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.77361000",
      "longitude": "-81.18038000"
    },
    {
      "name": "Starlight Village",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.88308000",
      "longitude": "-66.76905000"
    },
    {
      "name": "Steinbach",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.52579000",
      "longitude": "-96.68451000"
    },
    {
      "name": "Stephenville",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.55001000",
      "longitude": "-58.58180000"
    },
    {
      "name": "Stephenville Crossing",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "48.50001000",
      "longitude": "-58.43180000"
    },
    {
      "name": "Stettler",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.31683000",
      "longitude": "-112.71861000"
    },
    {
      "name": "Stirling",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.30012000",
      "longitude": "-77.54948000"
    },
    {
      "name": "Stonewall",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "50.13441000",
      "longitude": "-97.32676000"
    },
    {
      "name": "Stoney Point",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.26681000",
      "longitude": "-79.53292000"
    },
    {
      "name": "Stony Plain",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.53343000",
      "longitude": "-114.00205000"
    },
    {
      "name": "Stratford",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.36679000",
      "longitude": "-80.94972000"
    },
    {
      "name": "Strathmore",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.05011000",
      "longitude": "-113.38523000"
    },
    {
      "name": "Sudbury",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "47.16679000",
      "longitude": "-81.99980000"
    },
    {
      "name": "Summerland",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.59977000",
      "longitude": "-119.66911000"
    },
    {
      "name": "Summerside",
      "countryCode": "CA",
      "stateCode": "PE",
      "latitude": "46.39593000",
      "longitude": "-63.78762000"
    },
    {
      "name": "Sundre",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.80010000",
      "longitude": "-114.63532000"
    },
    {
      "name": "Surrey",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.10635000",
      "longitude": "-122.82509000"
    },
    {
      "name": "Sussex",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.72266000",
      "longitude": "-65.50663000"
    },
    {
      "name": "Sutton",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.10008000",
      "longitude": "-72.61582000"
    },
    {
      "name": "Swan Hills",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.71681000",
      "longitude": "-115.40226000"
    },
    {
      "name": "Swan River",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "52.10580000",
      "longitude": "-101.26759000"
    },
    {
      "name": "Swift Current",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.28337000",
      "longitude": "-107.80135000"
    },
    {
      "name": "Sydney",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "46.13510000",
      "longitude": "-60.18310000"
    },
    {
      "name": "Sydney Mines",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "46.23669000",
      "longitude": "-60.21767000"
    },
    {
      "name": "Sylvan Lake",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.31100000",
      "longitude": "-114.08375000"
    },
    {
      "name": "Taber",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "49.78703000",
      "longitude": "-112.14603000"
    },
    {
      "name": "Tamarack",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.46441000",
      "longitude": "-113.36235000"
    },
    {
      "name": "Tavistock",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.31679000",
      "longitude": "-80.83302000"
    },
    {
      "name": "Temiskaming Shores",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "47.49376000",
      "longitude": "-79.71529000"
    },
    {
      "name": "Terrace",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.51634000",
      "longitude": "-128.60345000"
    },
    {
      "name": "Terrasse-des-Pins",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.86449000",
      "longitude": "-74.06627000"
    },
    {
      "name": "Terrebonne",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.70004000",
      "longitude": "-73.64732000"
    },
    {
      "name": "The Pas",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "53.82509000",
      "longitude": "-101.25413000"
    },
    {
      "name": "Thessalon",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.25006000",
      "longitude": "-83.56660000"
    },
    {
      "name": "Thetford-Mines",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.09371000",
      "longitude": "-71.30539000"
    },
    {
      "name": "Thompson",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "55.74350000",
      "longitude": "-97.85579000"
    },
    {
      "name": "Thorold",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.11682000",
      "longitude": "-79.19958000"
    },
    {
      "name": "Three Hills",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "51.70012000",
      "longitude": "-113.26863000"
    },
    {
      "name": "Thunder Bay",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.38202000",
      "longitude": "-89.25018000"
    },
    {
      "name": "Thunder Bay District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "49.50011000",
      "longitude": "-88.50004000"
    },
    {
      "name": "Thurso",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.60010000",
      "longitude": "-75.24931000"
    },
    {
      "name": "Timiskaming District",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "47.75016000",
      "longitude": "-80.33303000"
    },
    {
      "name": "Timmins",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "48.46686000",
      "longitude": "-81.33312000"
    },
    {
      "name": "Tisdale",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.85002000",
      "longitude": "-104.05096000"
    },
    {
      "name": "Tobermory",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.25007000",
      "longitude": "-81.66647000"
    },
    {
      "name": "Tofield",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.36684000",
      "longitude": "-112.66862000"
    },
    {
      "name": "Tofino",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.15314000",
      "longitude": "-125.90744000"
    },
    {
      "name": "Torbay",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.66659000",
      "longitude": "-52.73135000"
    },
    {
      "name": "Toronto",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.70011000",
      "longitude": "-79.41630000"
    },
    {
      "name": "Toronto county",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.69655000",
      "longitude": "-79.42909000"
    },
    {
      "name": "Tottenham",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.02437000",
      "longitude": "-79.80553000"
    },
    {
      "name": "Tracadie-Sheila",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "47.51444000",
      "longitude": "-64.91806000"
    },
    {
      "name": "Trail",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.09983000",
      "longitude": "-117.70223000"
    },
    {
      "name": "Trois-Rivières",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.34515000",
      "longitude": "-72.54770000"
    },
    {
      "name": "Truro",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.36685000",
      "longitude": "-63.26538000"
    },
    {
      "name": "Tsawwassen",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.01667000",
      "longitude": "-123.08333000"
    },
    {
      "name": "Tumbler Ridge",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "55.13027000",
      "longitude": "-120.99415000"
    },
    {
      "name": "Tweed",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.47512000",
      "longitude": "-77.31616000"
    },
    {
      "name": "Two Hills",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.71686000",
      "longitude": "-111.75181000"
    },
    {
      "name": "Témiscaming",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.72122000",
      "longitude": "-79.09712000"
    },
    {
      "name": "Ucluelet",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.94153000",
      "longitude": "-125.54635000"
    },
    {
      "name": "Unity",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.45014000",
      "longitude": "-109.16816000"
    },
    {
      "name": "Upper Island Cove",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.64989000",
      "longitude": "-53.21478000"
    },
    {
      "name": "Uxbridge",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.10012000",
      "longitude": "-79.11628000"
    },
    {
      "name": "Val-David",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.03338000",
      "longitude": "-74.21592000"
    },
    {
      "name": "Val-Morin",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.00008000",
      "longitude": "-74.18251000"
    },
    {
      "name": "Val-d'Or",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "48.09740000",
      "longitude": "-77.79737000"
    },
    {
      "name": "Val-des-Monts",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.65010000",
      "longitude": "-75.66604000"
    },
    {
      "name": "Valcourt",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.50008000",
      "longitude": "-72.31581000"
    },
    {
      "name": "Valley East",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "46.66773000",
      "longitude": "-81.00028000"
    },
    {
      "name": "Valleyview",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.06673000",
      "longitude": "-117.28585000"
    },
    {
      "name": "Vallée-Jonction",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.37441000",
      "longitude": "-70.91881000"
    },
    {
      "name": "Vancouver",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.24966000",
      "longitude": "-123.11934000"
    },
    {
      "name": "Vanderhoof",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "54.01657000",
      "longitude": "-124.01982000"
    },
    {
      "name": "Vanier",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.43990000",
      "longitude": "-75.66498000"
    },
    {
      "name": "Varennes",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.68338000",
      "longitude": "-73.43246000"
    },
    {
      "name": "Vaudreuil-Dorion",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.40008000",
      "longitude": "-74.03251000"
    },
    {
      "name": "Vaughan",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.83610000",
      "longitude": "-79.49827000"
    },
    {
      "name": "Vegreville",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.50015000",
      "longitude": "-112.05182000"
    },
    {
      "name": "Venise-en-Québec",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.08338000",
      "longitude": "-73.13245000"
    },
    {
      "name": "Verchères",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.78338000",
      "longitude": "-73.34916000"
    },
    {
      "name": "Vermilion",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.35409000",
      "longitude": "-110.85849000"
    },
    {
      "name": "Vernon",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.26729000",
      "longitude": "-119.27337000"
    },
    {
      "name": "Victoria",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "48.43590000",
      "longitude": "-123.35155000"
    },
    {
      "name": "Victoriaville",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.05007000",
      "longitude": "-71.96579000"
    },
    {
      "name": "Viking",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.10014000",
      "longitude": "-111.76844000"
    },
    {
      "name": "Ville-Marie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.33345000",
      "longitude": "-79.43297000"
    },
    {
      "name": "Vineland",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.15012000",
      "longitude": "-79.39960000"
    },
    {
      "name": "Virden",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.85080000",
      "longitude": "-100.93262000"
    },
    {
      "name": "Virgil",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.21682000",
      "longitude": "-79.13288000"
    },
    {
      "name": "Vulcan",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "50.40008000",
      "longitude": "-113.25189000"
    },
    {
      "name": "Wabana",
      "countryCode": "CA",
      "stateCode": "NL",
      "latitude": "47.63319000",
      "longitude": "-52.94806000"
    },
    {
      "name": "Wadena",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.94999000",
      "longitude": "-103.80102000"
    },
    {
      "name": "Wainwright",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.83482000",
      "longitude": "-110.85342000"
    },
    {
      "name": "Wakefield",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.66680000",
      "longitude": "-75.83265000"
    },
    {
      "name": "Walnut Grove",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.16473000",
      "longitude": "-122.64042000"
    },
    {
      "name": "Walpole Island",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.61520000",
      "longitude": "-82.51398000"
    },
    {
      "name": "Warman",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.31679000",
      "longitude": "-106.56791000"
    },
    {
      "name": "Warwick",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.95007000",
      "longitude": "-71.98240000"
    },
    {
      "name": "Wasaga Beach",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.51680000",
      "longitude": "-80.01637000"
    },
    {
      "name": "Waskaganish",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "51.48333000",
      "longitude": "-78.75000000"
    },
    {
      "name": "Waswanipi",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "49.73346000",
      "longitude": "-76.16604000"
    },
    {
      "name": "Waterford",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.93340000",
      "longitude": "-80.28296000"
    },
    {
      "name": "Waterloo",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.46680000",
      "longitude": "-80.51639000"
    },
    {
      "name": "Waterloo",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.35008000",
      "longitude": "-72.51582000"
    },
    {
      "name": "Watford",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.95008000",
      "longitude": "-81.88309000"
    },
    {
      "name": "Watrous",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.66677000",
      "longitude": "-105.46788000"
    },
    {
      "name": "Watson Lake",
      "countryCode": "CA",
      "stateCode": "YT",
      "latitude": "60.06349000",
      "longitude": "-128.70893000"
    },
    {
      "name": "Wawa",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "47.98877000",
      "longitude": "-84.77411000"
    },
    {
      "name": "Weedon Centre",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.70802000",
      "longitude": "-71.45986000"
    },
    {
      "name": "Welcome Beach",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.47959000",
      "longitude": "-123.89239000"
    },
    {
      "name": "Welland",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.98342000",
      "longitude": "-79.24958000"
    },
    {
      "name": "Wellesley",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.47691000",
      "longitude": "-80.76209000"
    },
    {
      "name": "Wells",
      "countryCode": "CA",
      "stateCode": "NB",
      "latitude": "45.39274000",
      "longitude": "-65.92313000"
    },
    {
      "name": "Wembley",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.14995000",
      "longitude": "-119.13602000"
    },
    {
      "name": "Wendover",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.57275000",
      "longitude": "-75.12757000"
    },
    {
      "name": "West End",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.28333000",
      "longitude": "-123.13333000"
    },
    {
      "name": "West Kelowna",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.86250000",
      "longitude": "-119.58333000"
    },
    {
      "name": "West Lorne",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.60009000",
      "longitude": "-81.59976000"
    },
    {
      "name": "West St. Paul",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.99940000",
      "longitude": "-97.16284000"
    },
    {
      "name": "West Vancouver",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.36672000",
      "longitude": "-123.16652000"
    },
    {
      "name": "Westlake",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "55.22228000",
      "longitude": "-118.80415000"
    },
    {
      "name": "Westlock",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.15016000",
      "longitude": "-113.86876000"
    },
    {
      "name": "Westmount",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.48341000",
      "longitude": "-73.59918000"
    },
    {
      "name": "Wetaskiwin",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "52.96683000",
      "longitude": "-113.36869000"
    },
    {
      "name": "Weyburn",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "49.66675000",
      "longitude": "-103.85109000"
    },
    {
      "name": "Weymontachie",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "47.89940000",
      "longitude": "-73.77720000"
    },
    {
      "name": "Whistler",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "50.11817000",
      "longitude": "-122.95396000"
    },
    {
      "name": "White City",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "50.43338000",
      "longitude": "-104.36778000"
    },
    {
      "name": "White Rock",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "49.01636000",
      "longitude": "-122.80260000"
    },
    {
      "name": "Whitecourt",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "54.15015000",
      "longitude": "-115.68548000"
    },
    {
      "name": "Whitehorse",
      "countryCode": "CA",
      "stateCode": "YT",
      "latitude": "60.71611000",
      "longitude": "-135.05375000"
    },
    {
      "name": "Wild Rose",
      "countryCode": "CA",
      "stateCode": "AB",
      "latitude": "53.47080000",
      "longitude": "-113.38119000"
    },
    {
      "name": "Wilkie",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "52.41683000",
      "longitude": "-108.70142000"
    },
    {
      "name": "Williams Lake",
      "countryCode": "CA",
      "stateCode": "BC",
      "latitude": "52.14153000",
      "longitude": "-122.14451000"
    },
    {
      "name": "Willowdale",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.76672000",
      "longitude": "-79.39909000"
    },
    {
      "name": "Winchester",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "45.08340000",
      "longitude": "-75.34933000"
    },
    {
      "name": "Windsor",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.56678000",
      "longitude": "-71.99909000"
    },
    {
      "name": "Windsor",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "44.98345000",
      "longitude": "-64.13204000"
    },
    {
      "name": "Windsor",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "42.30008000",
      "longitude": "-83.01654000"
    },
    {
      "name": "Wingham",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.88793000",
      "longitude": "-81.31145000"
    },
    {
      "name": "Winkler",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.18170000",
      "longitude": "-97.94104000"
    },
    {
      "name": "Winnipeg",
      "countryCode": "CA",
      "stateCode": "MB",
      "latitude": "49.88440000",
      "longitude": "-97.14704000"
    },
    {
      "name": "Wolfville",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "45.08345000",
      "longitude": "-64.36546000"
    },
    {
      "name": "Woodstock",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "43.13339000",
      "longitude": "-80.74970000"
    },
    {
      "name": "Wynyard",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.76674000",
      "longitude": "-104.18436000"
    },
    {
      "name": "Yamachiche",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "46.26676000",
      "longitude": "-72.83243000"
    },
    {
      "name": "Yarmouth",
      "countryCode": "CA",
      "stateCode": "NS",
      "latitude": "43.83345000",
      "longitude": "-66.11557000"
    },
    {
      "name": "Yellowknife",
      "countryCode": "CA",
      "stateCode": "NT",
      "latitude": "62.45411000",
      "longitude": "-114.37248000"
    },
    {
      "name": "York",
      "countryCode": "CA",
      "stateCode": "ON",
      "latitude": "44.00011000",
      "longitude": "-79.46632000"
    },
    {
      "name": "Yorkton",
      "countryCode": "CA",
      "stateCode": "SK",
      "latitude": "51.21670000",
      "longitude": "-102.46766000"
    },
    {
      "name": "le Plateau",
      "countryCode": "CA",
      "stateCode": "QC",
      "latitude": "45.43514000",
      "longitude": "-75.78030000"
    }
  ]